(function () {
  try { window.__swishcbContactLoaded = true; } catch (_) {}
  const HAS_DOM = typeof window !== 'undefined' && typeof document !== 'undefined';
  const MAX_PREVIEW_BYTES = 250 * 1024;
  const MAX_PREVIEW_DATA_CHARS = 60000;
  const MAX_CONTACT_BODY_CHARS = 3500;
  const MAX_CONTACT_SUMMARY_CHARS = 1500;
  const MAX_CONTACT_DETAILS_CHARS = 12000;
  const MAX_CONTACT_CONFIG_CHARS = MAX_CONTACT_DETAILS_CHARS;
  const MAX_CONTACT_PAGE_URL_CHARS = 300;
  const MAX_CONTACT_SHARE_URL_CHARS = 6000;
  const MAX_CONTACT_UPLOAD_FIELD_CHARS = 6000;
  const MAX_LOGO_FILE_BYTES = 3 * 1024 * 1024;
  const MAX_TOTAL_LOGO_BYTES = 8 * 1024 * 1024;
  const MAX_TOTAL_ATTACHMENT_BYTES = 10 * 1024 * 1024;
  const MAX_SHARE_IMAGE_BYTES = 4 * 1024 * 1024;

  function shouldGeneratePreviewData(opts) {
    return !(opts && opts.previewAttached);
  }

  function getRoot() {
    return document.getElementById('swish-court-builder');
  }

  function getContactForm(root) {
    if (!root) return null;
    return root.querySelector('#SwishContactPanel');
  }

  function getApi() {
    return (typeof window !== 'undefined' && window.SwishCourtBuilder) ? window.SwishCourtBuilder : null;
  }

  function waitForApi(timeoutMs) {
    const start = Date.now();
    return new Promise((resolve) => {
      const tick = () => {
        const api = getApi();
        if (api && typeof api.getContactPayload === 'function') return resolve(api);
        if (Date.now() - start > timeoutMs) return resolve(null);
        setTimeout(tick, 100);
      };
      tick();
    });
  }

  function nowMs() {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      return performance.now();
    }
    return Date.now();
  }

  function createDebugSession() {
    const startedAt = nowMs();
    return {
      startedAtIso: (new Date()).toISOString(),
      marks: [],
      mark(label, extra) {
        const elapsedMs = Math.round((nowMs() - startedAt) * 100) / 100;
        this.marks.push({
          label,
          elapsedMs,
          extra: extra || null
        });
      }
    };
  }

  function publishDebugSession(session, result, error) {
    if (!session) return;

    const payload = {
      startedAt: session.startedAtIso,
      marks: Array.isArray(session.marks) ? session.marks.slice() : [],
      result: result || null,
      error: error ? String((error && error.message) || error) : null
    };

    try {
      window.__swishcbContactLastSubmission = payload;
    } catch (_) {}

  }

  function getSubmitButton(form) {
    if (!form) return null;
    return form.querySelector('[data-swishcb-contact-submit], button[type="submit"], input[type="submit"]');
  }

  function getSubmitLabel(form) {
    if (!form) return null;
    return form.querySelector('[data-swishcb-contact-submit-label]');
  }

  function getStatusBox(form) {
    if (!form) return null;
    return form.querySelector('[data-swishcb-contact-status]');
  }

  function setStatusMessage(form, message, isError) {
    const box = getStatusBox(form);
    if (!box) return;

    const text = message == null ? '' : String(message);
    box.hidden = !text;
    box.textContent = text;
    box.dataset.state = isError ? 'error' : 'info';
    box.setAttribute('role', isError ? 'alert' : 'status');
  }

  function clearStatusMessage(form) {
    setStatusMessage(form, '', false);
  }

  function setSubmittingState(form, isSubmitting) {
    const button = getSubmitButton(form);
    if (!button) return;

    form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    button.disabled = !!isSubmitting;

    const label = getSubmitLabel(form);
    if (label) {
      if (!button.dataset.swishcbDefaultLabel) {
        button.dataset.swishcbDefaultLabel = label.textContent || 'Receive Prices';
      }
      label.textContent = isSubmitting ? 'Sending...' : button.dataset.swishcbDefaultLabel;
      return;
    }

    if (button.tagName === 'INPUT') {
      if (!button.dataset.swishcbDefaultLabel) {
        button.dataset.swishcbDefaultLabel = button.value || 'Receive Prices';
      }
      button.value = isSubmitting ? 'Sending...' : button.dataset.swishcbDefaultLabel;
      return;
    }

    if (!button.dataset.swishcbDefaultLabel) {
      button.dataset.swishcbDefaultLabel = button.textContent || 'Receive Prices';
    }
    button.textContent = isSubmitting ? 'Sending...' : button.dataset.swishcbDefaultLabel;
  }

  function ensureField(form, selector, fallbackTag, attrs) {
    let field = form.querySelector(selector);
    if (field) return field;
    const el = document.createElement(fallbackTag || 'input');
    if (attrs) {
      Object.keys(attrs).forEach((key) => el.setAttribute(key, attrs[key]));
    }
    form.appendChild(el);
    return el;
  }

  function setFieldValue(field, value) {
    if (!field) return;
    field.value = value == null ? '' : String(value);
  }

  function setFieldSubmissionValue(field, value) {
    const text = value == null ? '' : String(value);
    setFieldValue(field, text);
    if (field) field.disabled = !text;
    return text;
  }

  function ensureHiddenTextarea(form, selector, attrs) {
    const field = ensureField(form, selector, 'textarea', attrs);
    field.hidden = true;
    return field;
  }

  function resetGeneratedField(field) {
    if (!field) return;
    field.hidden = true;
    field.disabled = true;
    setFieldValue(field, '');
  }

  function isContactTestMode() {
    if (typeof window === 'undefined') return false;
    if (window.__SWISHCB_TEST__) return true;
    try {
      return String(new URLSearchParams(window.location.search || '').get('swishcb_test') || '') === '1';
    } catch (_) {
      return false;
    }
  }

  function clearFileInput(input) {
    if (!input) return;
    try {
      input.value = '';
    } catch (_) {}
    input.disabled = true;
  }

  function buildContactReturnToValue() {
    if (typeof window === 'undefined' || !window.location) return 'back';

    const path = window.location.pathname || '/';
    const search = window.location.search || '';
    const hash = window.location.hash || '#SwishContactPanel';
    return `${path}${search}${hash}`;
  }

  function ensureReturnToField(form) {
    if (!form) return null;

    let field = form.querySelector('input[name="return_to"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'return_to';
      field.id = 'swishcb-contact-return-to';
      form.appendChild(field);
    }

    field.disabled = false;
    field.value = buildContactReturnToValue();
    return field;
  }

  function prepareNativeContactPost(form) {
    if (!form) return;

    ensureReturnToField(form);
    form.setAttribute('method', 'post');
    form.removeAttribute('data-shopify-captcha');
    form.removeAttribute('enctype');
    try { form.enctype = 'application/x-www-form-urlencoded'; } catch (_) {}

    const submitButton = getSubmitButton(form);
    if (submitButton) {
      submitButton.removeAttribute('formaction');
      submitButton.removeAttribute('formenctype');
      submitButton.removeAttribute('formmethod');
    }

    clearFileInput(form.querySelector('#swishcb-contact-preview-file'));
    clearFileInput(form.querySelector('#swishcb-contact-logo-files'));
  }

  function normalizeValue(value, fallback) {
    const text = value == null ? '' : String(value);
    const trimmed = text.trim();
    return trimmed ? trimmed : (fallback || '-');
  }

  function readFormValue(form, selector) {
    if (!form) return '';
    const el = form.querySelector(selector);
    if (!el || !('value' in el)) return '';
    return String(el.value || '');
  }

  function readFormCheckbox(form, selector) {
    if (!form) return false;
    const el = form.querySelector(selector);
    return !!(el && el.checked);
  }

  function safeNumber(value) {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  function getContactUnits(form) {
    const radio = form ? form.querySelector('input[name="swishcb-contact-units"]:checked') : null;
    return radio ? radio.value : null;
  }

  function getBuilderUnits(root) {
    const radio = root ? root.querySelector('input[name="swishcb-units"]:checked') : null;
    return radio ? radio.value : null;
  }

  function getUnitFromConfig(config) {
    if (!config || typeof config !== 'object') return null;
    const u = String(config.units || '').toLowerCase();
    return (u === 'ft' || u === 'm') ? u : null;
  }

  function buildPayload(api, form, root) {
    const builderRoot = root || getRoot();
    const payload = api && typeof api.getContactPayload === 'function'
      ? api.getContactPayload()
      : {};

    const configField = form ? form.querySelector('#swishcb-contact-config') : null;
    const configRaw = configField ? String(configField.value || '') : '';
    let config = null;
    try { config = configRaw ? JSON.parse(configRaw) : null; } catch (_) { config = null; }

    payload.configRaw = payload.configRaw || configRaw;
    payload.config = payload.config || config;
    payload.timestamp = payload.timestamp || (new Date()).toISOString();

    const fallbackUrl = (typeof window !== 'undefined' && window.location) ? window.location.href : '';
    payload.pageUrl = payload.pageUrl || fallbackUrl;
    payload.shareUrl = payload.shareUrl || payload.pageUrl || fallbackUrl;

    payload.units = payload.units || getUnitFromConfig(config) || getContactUnits(form) || getBuilderUnits(builderRoot) || 'm';
    payload.lengthM = (payload.lengthM != null) ? payload.lengthM : safeNumber(config && config.length);
    payload.widthM = (payload.widthM != null) ? payload.widthM : safeNumber(config && config.width);
    payload.rotation = (payload.rotation != null) ? payload.rotation : safeNumber(config && config.rotation);
    payload.ruleset = payload.ruleset || (config && config.ruleset) || null;
    payload.colors = payload.colors || (config && config.colors) || null;
    payload.detailColors = payload.detailColors || (config && config.detailColors) || null;
    payload.hiddenDetails = payload.hiddenDetails || (config && config.hiddenDetails) || [];
    payload.detailVisibility = payload.detailVisibility || (config && config.detailVisibility) || null;
    payload.extraSports = payload.extraSports || (config && config.extras) || null;
    payload.texts = payload.texts || (config && Array.isArray(config.texts) ? config.texts : []);
    if (!payload.view && config && config.view3d) {
      payload.view = {
        mode: null,
        zoom: Number.isFinite(config.view3d.zoom) ? config.view3d.zoom : null,
        autoRotate: !!config.view3d.autoRotate
      };
    }

    if (!payload.hoopsMode) {
      payload.hoopsMode = readHoopsModeFromDom(builderRoot);
    }
    if (!payload.hoopSelection) {
      payload.hoopSelection = readHoopSelectionFromDom(builderRoot);
    }
    if (!payload.borderSelection) {
      payload.borderSelection = readBorderSelectionFromDom(builderRoot, payload.hoopSelection);
    }
    if (!payload.hoopOverhangsM || !['left', 'right', 'top', 'bottom'].some((side) => Number.isFinite(payload.hoopOverhangsM[side]))) {
      const overhangs = readOverhangsFromDom(builderRoot, payload.units);
      if (overhangs) payload.hoopOverhangsM = overhangs;
    }

    return payload;
  }

  function buildPrimePayload(form, root) {
    try {
      return buildPayload(getApi(), form, root) || {};
    } catch (_) {
      const fallbackUrl = (typeof window !== 'undefined' && window.location) ? window.location.href : '';
      return {
        pageUrl: fallbackUrl,
        shareUrl: fallbackUrl
      };
    }
  }

  function m2ft(m) {
    return Number(m) * 3.28084;
  }

  function fmt(n, digits) {
    if (!Number.isFinite(n)) return '-';
    const d = Number.isFinite(digits) ? digits : 2;
    return Number(n).toFixed(d);
  }

  function fmtMetersFeet(m) {
    if (!Number.isFinite(m)) return '-';
    const mVal = fmt(m, 2);
    const ftVal = fmt(m2ft(m), 2);
    return `${mVal} m (${ftVal} ft)`;
  }

  function fmtDistanceByUnit(m, unit) {
    if (!Number.isFinite(m)) return '-';
    if (unit === 'ft') return `${fmt(m2ft(m), 2)} ft`;
    return `${fmt(m, 2)} m`;
  }

  function fmtTrim(n, digits) {
    if (!Number.isFinite(n)) return '-';
    const d = Number.isFinite(digits) ? digits : 2;
    const fixed = Number(n).toFixed(d);
    return fixed.replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1');
  }

  function fmtBytes(bytes) {
    if (!Number.isFinite(bytes)) return '-';
    if (bytes < 1024) return `${bytes} B`;
    const kb = bytes / 1024;
    if (kb < 1024) return `${fmtTrim(kb, 1)} KB`;
    const mb = kb / 1024;
    return `${fmtTrim(mb, 2)} MB`;
  }

  function getTextLength(value) {
    if (value == null) return 0;
    return String(value).length;
  }

  function sanitizeText(value) {
    return value == null ? '' : String(value).trim();
  }

  function appendSubmissionNote(notes, message) {
    const text = sanitizeText(message);
    if (!text) return;
    if (notes.indexOf(text) !== -1) return;
    notes.push(text);
  }

  function getCanonicalPageUrl(rawUrl) {
    const fallback = (typeof window !== 'undefined' && window.location)
      ? `${window.location.origin}${window.location.pathname}`
      : '';
    const source = sanitizeText(rawUrl) || fallback;
    if (!source) return '';

    try {
      const url = new URL(source, fallback || undefined);
      return `${url.origin}${url.pathname}`;
    } catch (_) {
      return source.split('#')[0].split('?')[0];
    }
  }

  function omitOversizedValue(value, maxChars, label, notes) {
    const text = sanitizeText(value);
    if (!text) return '';
    if (text.length <= maxChars) return text;
    appendSubmissionNote(notes, `${label} was omitted because it exceeded ${maxChars} characters.`);
    return '';
  }

  function trimTextForField(value, maxChars, label) {
    const text = value == null ? '' : String(value);
    if (!text || text.length <= maxChars) return text;
    const suffix = `\n[${label} trimmed from ${text.length} characters]`;
    if (suffix.length >= maxChars) {
      return text.slice(0, maxChars);
    }
    return `${text.slice(0, maxChars - suffix.length)}${suffix}`;
  }

  function buildSubmissionNotesBlock(notes) {
    if (!Array.isArray(notes) || !notes.length) return '';
    return `\n\nSubmission notes\n- ${notes.join('\n- ')}`;
  }

  function buildUploadEndpoint() {
    if (typeof window === 'undefined' || !window.EComposer || !window.EComposer.proxy_path) {
      return null;
    }

    const proxyPath = String(window.EComposer.proxy_path || '').replace(/\/$/, '');
    if (!proxyPath) return null;

    try {
      return new URL(proxyPath + '/contact-form', window.location.origin).toString();
    } catch (_) {
      return window.location.origin + proxyPath + '/contact-form';
    }
  }

  async function uploadFile(endpoint, file, fileName) {
    const body = new FormData();
    body.append('file', file, fileName || 'upload.bin');

    const response = await fetch(endpoint, {
      method: 'POST',
      body,
      credentials: 'same-origin'
    });

    const payload = await response.json();
    if (!response.ok || !payload || payload.status !== 'success' || !payload.src_file) {
      throw new Error((payload && payload.message) || 'Upload failed.');
    }

    return payload.src_file;
  }

  let zipCrcTable = null;

  function getZipCrcTable() {
    if (zipCrcTable) return zipCrcTable;
    zipCrcTable = new Uint32Array(256);
    for (let i = 0; i < 256; i += 1) {
      let c = i;
      for (let k = 0; k < 8; k += 1) {
        c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
      }
      zipCrcTable[i] = c >>> 0;
    }
    return zipCrcTable;
  }

  function crc32Bytes(bytes) {
    const table = getZipCrcTable();
    let crc = 0xFFFFFFFF;
    for (let i = 0; i < bytes.length; i += 1) {
      crc = table[(crc ^ bytes[i]) & 0xFF] ^ (crc >>> 8);
    }
    return (crc ^ 0xFFFFFFFF) >>> 0;
  }

  function writeZipU16(view, offset, value) {
    view.setUint16(offset, value & 0xFFFF, true);
  }

  function writeZipU32(view, offset, value) {
    view.setUint32(offset, value >>> 0, true);
  }

  function getZipDosDateTime(date) {
    const d = date instanceof Date ? date : new Date();
    const year = Math.max(1980, d.getFullYear());
    const dosTime = ((d.getHours() & 0x1F) << 11) |
      ((d.getMinutes() & 0x3F) << 5) |
      (Math.floor(d.getSeconds() / 2) & 0x1F);
    const dosDate = (((year - 1980) & 0x7F) << 9) |
      (((d.getMonth() + 1) & 0x0F) << 5) |
      (d.getDate() & 0x1F);
    return { dosTime, dosDate };
  }

  function encodeZipText(value) {
    const text = value == null ? '' : String(value);
    if (typeof TextEncoder === 'function') return new TextEncoder().encode(text);
    const encoded = unescape(encodeURIComponent(text));
    const bytes = new Uint8Array(encoded.length);
    for (let i = 0; i < encoded.length; i += 1) bytes[i] = encoded.charCodeAt(i);
    return bytes;
  }

  function createStoredZipBlob(fileName, text) {
    const innerName = String(fileName || 'swish-court-builder-settings.json').replace(/[\\/:*?"<>|]+/g, '-');
    const nameBytes = encodeZipText(innerName || 'swish-court-builder-settings.json');
    const dataBytes = encodeZipText(text || '');
    const crc = crc32Bytes(dataBytes);
    const stamp = getZipDosDateTime(new Date());
    const flags = 0x0800;
    const method = 0;

    const local = new Uint8Array(30 + nameBytes.length);
    const localView = new DataView(local.buffer);
    writeZipU32(localView, 0, 0x04034B50);
    writeZipU16(localView, 4, 20);
    writeZipU16(localView, 6, flags);
    writeZipU16(localView, 8, method);
    writeZipU16(localView, 10, stamp.dosTime);
    writeZipU16(localView, 12, stamp.dosDate);
    writeZipU32(localView, 14, crc);
    writeZipU32(localView, 18, dataBytes.length);
    writeZipU32(localView, 22, dataBytes.length);
    writeZipU16(localView, 26, nameBytes.length);
    writeZipU16(localView, 28, 0);
    local.set(nameBytes, 30);

    const centralOffset = local.length + dataBytes.length;
    const central = new Uint8Array(46 + nameBytes.length);
    const centralView = new DataView(central.buffer);
    writeZipU32(centralView, 0, 0x02014B50);
    writeZipU16(centralView, 4, 20);
    writeZipU16(centralView, 6, 20);
    writeZipU16(centralView, 8, flags);
    writeZipU16(centralView, 10, method);
    writeZipU16(centralView, 12, stamp.dosTime);
    writeZipU16(centralView, 14, stamp.dosDate);
    writeZipU32(centralView, 16, crc);
    writeZipU32(centralView, 20, dataBytes.length);
    writeZipU32(centralView, 24, dataBytes.length);
    writeZipU16(centralView, 28, nameBytes.length);
    writeZipU16(centralView, 30, 0);
    writeZipU16(centralView, 32, 0);
    writeZipU16(centralView, 34, 0);
    writeZipU16(centralView, 36, 0);
    writeZipU32(centralView, 38, 0);
    writeZipU32(centralView, 42, 0);
    central.set(nameBytes, 46);

    const end = new Uint8Array(22);
    const endView = new DataView(end.buffer);
    writeZipU32(endView, 0, 0x06054B50);
    writeZipU16(endView, 4, 0);
    writeZipU16(endView, 6, 0);
    writeZipU16(endView, 8, 1);
    writeZipU16(endView, 10, 1);
    writeZipU32(endView, 12, central.length);
    writeZipU32(endView, 16, centralOffset);
    writeZipU16(endView, 20, 0);

    return new Blob([local, dataBytes, central, end], { type: 'application/zip' });
  }

  async function uploadJsonFile(endpoint, jsonText, fileName) {
    if (!endpoint || !jsonText) return '';
    const BlobCtor = (typeof Blob === 'function') ? Blob : null;
    if (!BlobCtor) return '';
    const blob = createStoredZipBlob(fileName || 'swish-court-builder-settings.json', jsonText);
    return uploadFile(endpoint, blob, 'swish-court-builder-settings.zip');
  }

  function isPublicHttpUrl(value) {
    return /^https?:\/\//i.test(String(value || '').trim());
  }

  function firstPublicUrl() {
    for (let i = 0; i < arguments.length; i += 1) {
      const text = String(arguments[i] || '').trim();
      if (isPublicHttpUrl(text)) return text;
    }
    return '';
  }

  function getShareAssetBlob(asset) {
    if (!asset || typeof asset !== 'object') return null;
    const BlobCtor = (typeof Blob === 'function') ? Blob : null;
    const FileCtor = (typeof File === 'function') ? File : null;
    if (asset.file && FileCtor && asset.file instanceof FileCtor) return asset.file;
    if (asset.blob && BlobCtor && asset.blob instanceof BlobCtor) return asset.blob;
    if (asset.file && BlobCtor && asset.file instanceof BlobCtor) return asset.file;
    return null;
  }

  function getShareAssetFileName(asset, fallback) {
    const raw = String((asset && (asset.fileName || (asset.file && asset.file.name))) || fallback || 'swish-court-share-file').trim();
    return raw.replace(/[\\/:*?"<>|]+/g, '-').slice(0, 120) || fallback || 'swish-court-share-file';
  }

  function getShareAssetMeta(asset, uploadedUrl, reason) {
    if (!asset || typeof asset !== 'object') return null;
    return {
      mode: asset.mode || null,
      kind: asset.kind || null,
      fileName: asset.fileName || (asset.file && asset.file.name) || null,
      mimeType: asset.mimeType || (asset.blob && asset.blob.type) || (asset.file && asset.file.type) || null,
      width: Number.isFinite(Number(asset.width)) ? Number(asset.width) : null,
      height: Number.isFinite(Number(asset.height)) ? Number(asset.height) : null,
      bytes: Number.isFinite(Number(asset.byteSize)) ? Number(asset.byteSize) : (
        asset.blob && Number.isFinite(Number(asset.blob.size)) ? Number(asset.blob.size) : null
      ),
      publicUrl: uploadedUrl || firstPublicUrl(asset.publicUrl, asset.deliveryUrl, asset.previewUrl),
      uploadedUrl: uploadedUrl || null,
      deliveryUrl: firstPublicUrl(asset.deliveryUrl),
      previewUrl: firstPublicUrl(asset.previewUrl),
      sourceKind: asset.sourceKind || null,
      deliverySource: asset.deliverySource || null,
      normalizationState: asset.normalizationState || null,
      uploadReason: reason || null
    };
  }

  async function uploadPreparedShareAsset(label, asset, uploadEndpoint, options, form, submissionNotes) {
    const opts = options && typeof options === 'object' ? options : {};
    const publicUrl = firstPublicUrl(asset && asset.publicUrl, asset && asset.deliveryUrl, asset && asset.previewUrl);
    const blob = getShareAssetBlob(asset);
    const fileName = getShareAssetFileName(asset, opts.fileName || 'swish-court-share-file');
    const maxBytes = Number.isFinite(opts.maxBytes) ? opts.maxBytes : MAX_SHARE_IMAGE_BYTES;

    if (opts.preferPublicUrl && publicUrl) {
      return getShareAssetMeta(asset, publicUrl, 'using hosted share export');
    }

    if (!blob && publicUrl) {
      return getShareAssetMeta(asset, publicUrl, 'using hosted share export');
    }

    if (!blob) {
      appendSubmissionNote(submissionNotes, `${label} was omitted because the browser did not provide a downloadable file.`);
      return getShareAssetMeta(asset, '', 'missing local file');
    }

    if (blob.size > maxBytes) {
      appendSubmissionNote(submissionNotes, `${label} was omitted because it exceeded ${fmtBytes(maxBytes)}.`);
      return getShareAssetMeta(asset, publicUrl, `exceeded ${fmtBytes(maxBytes)}`);
    }

    if (!uploadEndpoint) {
      appendSubmissionNote(submissionNotes, `${label} was omitted because file uploads are unavailable on this page.`);
      return getShareAssetMeta(asset, publicUrl, 'upload unavailable');
    }

    setStatusMessage(form, `Uploading ${label.toLowerCase()}...`, false);
    try {
      const uploadedUrl = await uploadFile(uploadEndpoint, blob, fileName);
      return getShareAssetMeta(asset, uploadedUrl, 'uploaded');
    } catch (error) {
      appendSubmissionNote(
        submissionNotes,
        `${label} could not be uploaded: ${(error && error.message) || 'Upload failed.'}`
      );
      return getShareAssetMeta(asset, publicUrl, 'upload failed');
    }
  }

  async function prepareInquiryShareMedia(api, uploadEndpoint, form, submissionNotes, debugSession) {
    const result = {
      exactPreviewUrl: '',
      shareHash: '',
      shareData: null,
      logoManifestUrl: '',
      design2d: null,
      errors: []
    };

    if (!api || typeof api.prepareContactShareAssets !== 'function') {
      appendSubmissionNote(submissionNotes, 'Share-window exact link and 2D export were omitted because this builder version does not expose inquiry share assets.');
      return result;
    }

    let prepared = null;
    try {
      setStatusMessage(form, 'Preparing exact share link and 2D design...', false);
      prepared = await api.prepareContactShareAssets({
        include2d: true,
        includeVideo: false
      });
    } catch (error) {
      appendSubmissionNote(
        submissionNotes,
        `Share-window exact link and 2D export could not be prepared: ${(error && error.message) || 'Share export failed.'}`
      );
      result.errors.push({
        stage: 'prepare-share-assets',
        message: (error && error.message) || 'Share export failed.'
      });
      return result;
    }

    prepared = prepared && typeof prepared === 'object' ? prepared : {};
    result.exactPreviewUrl = String(prepared.shareUrl || '').trim();
    result.shareHash = String(prepared.shareHash || '').trim();
    result.shareData = prepared.shareData || null;
    result.logoManifestUrl = String(prepared.logoManifestUrl || '').trim();
    result.errors = Array.isArray(prepared.errors) ? prepared.errors.slice() : [];

    if (result.errors.length) {
      appendSubmissionNote(
        submissionNotes,
        `Some share export steps reported issues: ${result.errors.map((error) => `${error.stage || 'share'}: ${error.message || 'failed'}`).join('; ')}`
      );
    }

    if (debugSession) {
      debugSession.mark('share-media-prepared', {
        exactPreviewUrl: !!result.exactPreviewUrl,
        design2d: !!prepared.design2d,
        video3d: false,
        errors: result.errors.length
      });
    }

    result.design2d = await uploadPreparedShareAsset(
      '2D design image',
      prepared.design2d,
      uploadEndpoint,
      {
        fileName: 'swish-court-2d-design.png',
        maxBytes: MAX_SHARE_IMAGE_BYTES,
        preferPublicUrl: false
      },
      form,
      submissionNotes
    );

    return result;
  }

  function summarizeRawText(value) {
    const length = getTextLength(value);
    if (!length) return null;
    return {
      omitted: true,
      length
    };
  }

  function makeJsonSafe(value, seen) {
    if (value == null) return value;
    const type = typeof value;
    if (type === 'string' || type === 'number' || type === 'boolean') {
      if (type === 'number') return Number.isFinite(value) ? value : null;
      return value;
    }
    if (type !== 'object') return null;
    const FileCtor = (typeof File === 'function') ? File : null;
    const BlobCtor = (typeof Blob === 'function') ? Blob : null;
    if (FileCtor && value instanceof FileCtor) {
      return {
        fileName: value.name || '',
        fileType: value.type || '',
        fileSize: Number(value.size) || 0,
        fileLastModified: Number(value.lastModified) || 0
      };
    }
    if (BlobCtor && value instanceof BlobCtor) {
      return {
        blobType: value.type || '',
        blobSize: Number(value.size) || 0
      };
    }
    const guard = seen || [];
    if (guard.indexOf(value) !== -1) return '[Circular]';
    const nextSeen = guard.concat([value]);
    if (Array.isArray(value)) {
      return value.map((item) => makeJsonSafe(item, nextSeen));
    }
    const out = {};
    Object.keys(value).forEach((key) => {
      const item = value[key];
      if (typeof item === 'function' || typeof item === 'undefined') return;
      out[key] = makeJsonSafe(item, nextSeen);
    });
    return out;
  }

  function buildFullBuilderPayload(payload, meta) {
    const source = payload && typeof payload === 'object' ? payload : {};
    const safe = makeJsonSafe(source) || {};
    const uploadedLogoUrls = meta && Array.isArray(meta.uploadedLogoUrls) ? meta.uploadedLogoUrls.slice() : [];
    const uploadedPreviewUrl = meta && meta.previewUrl ? String(meta.previewUrl) : '';
    const uploadedDesign2dUrl = meta && meta.design2dUrl ? String(meta.design2dUrl) : '';
    const exactPreviewUrl = meta && meta.exactPreviewUrl ? String(meta.exactPreviewUrl) : '';
    safe.logoFiles = Array.isArray(source.logoFiles)
      ? source.logoFiles.map((file) => makeJsonSafe(file))
      : [];
    safe.uploadedLogoUrls = uploadedLogoUrls;
    safe.uploadedPreviewUrl = uploadedPreviewUrl || null;
    safe.uploadedDesign2dUrl = uploadedDesign2dUrl || null;
    safe.uploadedVideo3dUrl = null;
    safe.exactPreviewUrl = exactPreviewUrl || safe.shareUrl || null;
    safe.captureCompleteness = {
      fullCanonicalPayload: true,
      binaryLogoFilesRepresentedAsMetadata: true,
      uploadedLogoUrlsIncluded: uploadedLogoUrls,
      uploadedPreviewUrl: uploadedPreviewUrl || null,
      uploadedDesign2dUrl: uploadedDesign2dUrl || null,
      uploadedVideo3dUrl: null,
      exactPreviewUrl: exactPreviewUrl || safe.shareUrl || null
    };
    return safe;
  }

  function buildSettingsIndex(payload) {
    const p = payload && typeof payload === 'object' ? payload : {};
    return {
      mode: p.mode || p.courtMode || 'single',
      courtType: p.courtType || null,
      ruleset: p.ruleset || null,
      units: p.units || null,
      sizeM: { length: p.lengthM ?? null, width: p.widthM ?? null },
      rotation: p.rotation ?? null,
      measurements: p.measurements || null,
      lineSize: {
        selected: p.nonBasketballLineSizeMode || null,
        effective: p.nonBasketballLineSizeEffectiveMode || null,
        geometry: p.nonBasketballLineSizeGeometry || null
      },
      tiles: {
        enabled: p.tilesEnabled ?? !!p.tileCounts,
        series: p.tileSeries || (p.shareData && p.shareData.ts) || null,
        edges: p.tileEdges || null,
        edgeMask: p.tileEdgeMask ?? null,
        edgeSizeM: p.tileEdgeSizeM ?? null,
        counts: p.tileCounts || null,
        footprintM: p.tileFootprintM || null,
        installedSurfaceM: p.installedSurfaceM || null,
        materialCounts: p.tileMaterialCounts || null,
        materialOwnership: p.tileMaterialOwnership || null
      },
      hoops: {
        mode: p.hoopsMode || null,
        lineType: p.hoopLineType || null,
        preset: p.hoopModelPreset || null,
        selection: p.hoopSelection || null,
        overhangsM: p.hoopOverhangsM || null,
        overhangEditedSides: p.hoopOverhangEditedSides || [],
        presetGeometry: p.hoopPresetGeometry || null
      },
      borders: {
        selection: p.borderSelection || null,
        sizesM: p.borderSizesM || null
      },
      basketballKey: {
        matchKeyMode: p.keyDimensionsM && p.keyDimensionsM.mode ? p.keyDimensionsM.mode : (p.shareData && p.shareData.kta) || null,
        keyTileAlignment: p.keyTileAlignment || (p.shareData && p.shareData.kta) || null,
        overlayKeysLinkedToBase: p.overlayKeysLinkedToBase ?? null,
        dimensionsM: p.keyDimensionsM || null,
        dimensionsDisplay: p.keyDimensionsDisplay || null,
        centerCircle: p.centerCircleDiameter || null,
        threePoint: p.threePointDistance || null
      },
      sportFeatures: {
        futsal: {
          mode: p.futsalMode || null,
          playingAreaM: p.futsalPlayingAreaM || null,
          penaltyAreaM: p.futsalPenaltyAreaM || null
        },
        netball: {
          playingAreaM: p.netballPlayingAreaM || null,
          goalPostM: p.netballGoalPostM || null
        }
      },
      colors: {
        mainColors: p.colors || null,
        detailColors: p.detailColors || null,
        detailVisibility: p.detailVisibility || null,
        hiddenDetails: p.hiddenDetails || [],
        edgeColors: p.edgeColors || null
      },
      extraSports: p.extraSports || null,
      logos: {
        unit: p.logoUnit || null,
        manifestUrl: p.logoManifestUrl || null,
        logos: p.logos || []
      },
      view: p.view || null,
      share: {
        url: p.shareUrl || null,
        exactPreviewUrl: p.exactPreviewUrl || null,
        hash: p.shareHash || null,
        data: p.shareData || null,
        design2dUrl: p.uploadedDesign2dUrl || null,
        video3dUrl: null
      },
      multiCourt: {
        selectedCourtId: p.selectedCourtId || null,
        totalSurfaceM: p.totalSurfaceM || null,
        surfaceSettings: p.surfaceSettings || null,
        courts: Array.isArray(p.courts) ? p.courts : []
      }
    };
  }

  function fmtToggle(value) {
    return value ? 'On' : 'Off';
  }

  function fmtYesNo(value) {
    return value ? 'Yes' : 'No';
  }

  function fmtHoopsMode(value) {
    const raw = String(value ?? '').trim();
    if (!raw) return '-';
    if (raw === '0') return 'None';
    if (raw === '1') return '1 hoop';
    return `${raw} hoops`;
  }

  function fmtSelectionVerbose(sel) {
    if (!sel) return '-';
    return `Left ${fmtToggle(sel.leftOn)} | Right ${fmtToggle(sel.rightOn)} | Top ${fmtToggle(sel.topOn)} | Bottom ${fmtToggle(sel.bottomOn)}`;
  }

  function fmtOverhangByUnit(m, unit) {
    if (!Number.isFinite(m)) return '-';
    if (unit === 'ft') return `${fmt(m2ft(m), 2)} ft`;
    return `${fmtTrim(m * 100, 1)} cm`;
  }

  function fmtSelection(sel) {
    if (!sel) return '-';
    const items = [
      `L:${sel.leftOn ? 'on' : 'off'}`,
      `R:${sel.rightOn ? 'on' : 'off'}`,
      `T:${sel.topOn ? 'on' : 'off'}`,
      `B:${sel.bottomOn ? 'on' : 'off'}`
    ];
    return items.join(', ');
  }

  function getBuilderConfig() {
    try {
      return (typeof window !== 'undefined' && window.SwishCBConfig) ? window.SwishCBConfig : {};
    } catch (_) {
      return {};
    }
  }

  function humanizeBuilderId(value) {
    const raw = String(value || '').trim();
    if (!raw) return '';
    return raw
      .replace(/^extra_/i, '')
      .replace(/__/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/[_-]+/g, ' ')
      .replace(/\b3\s*pt\b/gi, '3PT')
      .replace(/\b3\s*point\b/gi, '3-point')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b[a-z]/g, (ch) => ch.toUpperCase());
  }

  function getExtraDefinitionById(extraId) {
    const cfg = getBuilderConfig();
    const list = Array.isArray(cfg.EXTRA_LINE_TYPES) ? cfg.EXTRA_LINE_TYPES : [];
    const wanted = String(extraId || '').trim().toLowerCase();
    if (!wanted) return null;
    return list.find((item) => item && String(item.id || '').toLowerCase() === wanted) || null;
  }

  function getDetailKeyForExtraDefinition(def) {
    const cfg = getBuilderConfig();
    const rulesetId = String(def && def.ruleset || '').trim().toUpperCase();
    const rules = rulesetId && cfg.RULESETS ? cfg.RULESETS[rulesetId] : null;
    return String((rules && rules.detailKey) || rulesetId || '').trim().toUpperCase();
  }

  function getDetailPartLabel(partId, detailKey) {
    const cfg = getBuilderConfig();
    const library = cfg.DETAIL_LIBRARY || {};
    const keys = detailKey ? [detailKey] : Object.keys(library || {});
    const wanted = String(partId || '').trim();
    if (!wanted) return '';
    for (let i = 0; i < keys.length; i += 1) {
      const meta = library[keys[i]];
      const parts = meta && Array.isArray(meta.parts) ? meta.parts : [];
      const part = parts.find((item) => item && item.id === wanted);
      if (!part) continue;
      let label = String(part.label || '').trim() || humanizeBuilderId(wanted);
      const groups = meta && Array.isArray(meta.groups) ? meta.groups : [];
      const group = groups.find((item) => item && item.id === part.group);
      const groupLabel = String(group && group.label || '').trim();
      if (
        groupLabel &&
        /^(left|right|top|bottom|center)$/i.test(String(part.group || '')) &&
        label.toLowerCase().indexOf(groupLabel.toLowerCase()) !== 0
      ) {
        label = `${groupLabel} ${label}`;
      }
      return label;
    }
    return humanizeBuilderId(wanted);
  }

  function parseExtraDetailIdForDisplay(id) {
    const text = String(id || '').trim();
    if (!text || text.indexOf('extra_') !== 0) return null;
    const rest = text.slice('extra_'.length);
    const idx = rest.indexOf('__');
    if (idx <= 0) return null;
    const extraId = rest.slice(0, idx).toLowerCase();
    const partId = rest.slice(idx + 2);
    if (!extraId || !partId) return null;
    return { extraId, partId };
  }

  function formatExtraIdForDisplay(extraId) {
    const def = getExtraDefinitionById(extraId);
    const label = String(def && def.label || '').trim();
    if (label) return label;
    return humanizeBuilderId(extraId);
  }

  function formatDetailIdForDisplay(id) {
    const parsed = parseExtraDetailIdForDisplay(id);
    if (parsed) {
      const def = getExtraDefinitionById(parsed.extraId);
      const detailKey = getDetailKeyForExtraDefinition(def);
      return `${formatExtraIdForDisplay(parsed.extraId)} - ${getDetailPartLabel(parsed.partId, detailKey)}`;
    }
    return getDetailPartLabel(id, '') || humanizeBuilderId(id);
  }

  function fmtKeyValueList(obj) {
    if (!obj || typeof obj !== 'object') return 'none';
    const entries = Object.entries(obj)
      .filter(([, v]) => v != null && String(v).trim() !== '')
      .map(([k, v]) => `${formatDetailIdForDisplay(k)}: ${v}`);
    return entries.length ? entries.join(', ') : 'none';
  }

  function fmtHiddenList(items) {
    return Array.isArray(items) && items.length ? items.map(formatDetailIdForDisplay).join(', ') : 'none';
  }

  function fmtVisibilityOverrides(detailVisibility) {
    if (!detailVisibility || typeof detailVisibility !== 'object') return 'none';
    const hidden = Object.entries(detailVisibility)
      .filter(([, v]) => v === false)
      .map(([k]) => formatDetailIdForDisplay(k));
    return hidden.length ? `hidden: ${hidden.join(', ')}` : 'none';
  }

  function fmtExtraSports(extraSports) {
    if (!extraSports || typeof extraSports !== 'object') return 'none';
    const entries = Object.entries(extraSports);
    const enabled = entries.filter(([, v]) => v && v.enabled);
    if (!enabled.length) return 'none';
    return enabled.map(([key, v]) => `${formatExtraIdForDisplay(key)}${v && v.color ? ` (${v.color})` : ''}`).join(', ');
  }

  function parseNumericInput(value) {
    const raw = value == null ? '' : String(value);
    const normalized = raw.replace(',', '.');
    const num = Number(normalized);
    return Number.isFinite(num) ? num : null;
  }

  function normalizeBuilderKey(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[_\s]+/g, '-');
  }

  function normalizeBuilderSport(value) {
    const normalized = normalizeBuilderKey(value);
    if (!normalized) return '';
    if (normalized.indexOf('pickleball') !== -1) return 'pickleball';
    if (normalized.indexOf('tennis') !== -1) return 'tennis';
    if (normalized.indexOf('padel') !== -1) return 'padel';
    if (normalized.indexOf('volleyball') !== -1) return 'volleyball';
    if (normalized.indexOf('futsal') !== -1) return 'futsal';
    if (normalized.indexOf('netball') !== -1) return 'netball';
    if (
      normalized.indexOf('basketball') !== -1 ||
      normalized.indexOf('fiba') !== -1 ||
      normalized.indexOf('nba') !== -1 ||
      normalized.indexOf('ncaa') !== -1 ||
      normalized === 'usahs' ||
      normalized.indexOf('high-school') !== -1 ||
      normalized.indexOf('highschool') !== -1 ||
      normalized === 'hs'
    ) {
      return 'basketball';
    }
    return normalized.replace(/-/g, ' ');
  }

  function mapRulesetToOfficialDimensionKey(ruleset) {
    const normalized = normalizeBuilderKey(ruleset);
    if (!normalized) return null;
    if (normalized.indexOf('fiba') !== -1 && normalized.indexOf('border') !== -1) return 'fiba-1900x3200-h2';
    if (normalized.indexOf('fiba') !== -1 && normalized.indexOf('half') !== -1) return 'fiba-1500x1400-h1';
    if (normalized.indexOf('fiba') !== -1) return 'fiba-1500x2800-h2';
    if (normalized.indexOf('nba') !== -1 && normalized.indexOf('half') !== -1 && normalized.indexOf('competition') !== -1) return 'nba-1924x1833-h1';
    if (normalized.indexOf('nba') !== -1 && normalized.indexOf('half') !== -1) return 'nba-1524x1433-h1';
    if (normalized.indexOf('nba') !== -1 && normalized.indexOf('border') !== -1) return 'nba-1924x3265-h2';
    if (normalized.indexOf('nba') !== -1) return 'nba-1524x2865-h2';
    if ((normalized.indexOf('ncaa') !== -1 || normalized.indexOf('college') !== -1) && normalized.indexOf('half') !== -1 && normalized.indexOf('competition') !== -1) return 'ncaa-1924x1833-h1';
    if ((normalized.indexOf('ncaa') !== -1 || normalized.indexOf('college') !== -1) && normalized.indexOf('half') !== -1) return 'ncaa-1524x1433-h1';
    if ((normalized.indexOf('ncaa') !== -1 || normalized.indexOf('college') !== -1) && normalized.indexOf('border') !== -1) return 'ncaa-1924x3265-h2';
    if (normalized.indexOf('ncaa') !== -1 || normalized.indexOf('college') !== -1) return 'ncaa-1524x2865-h2';
    if ((normalized === 'usahs' || normalized.indexOf('high-school') !== -1 || normalized.indexOf('highschool') !== -1 || normalized === 'hs') && normalized.indexOf('half') !== -1 && normalized.indexOf('competition') !== -1) return 'usahs-1924x1680-h1';
    if ((normalized === 'usahs' || normalized.indexOf('high-school') !== -1 || normalized.indexOf('highschool') !== -1 || normalized === 'hs') && normalized.indexOf('half') !== -1) return 'usahs-1524x1280-h1';
    if ((normalized === 'usahs' || normalized.indexOf('high-school') !== -1 || normalized.indexOf('highschool') !== -1 || normalized === 'hs') && normalized.indexOf('border') !== -1) return 'usahs-1924x2960-h2';
    if (normalized === 'usahs' || normalized.indexOf('high-school') !== -1 || normalized.indexOf('highschool') !== -1 || normalized === 'hs') return 'usahs-1524x2560-h2';
    if (normalized.indexOf('pickleball') !== -1) return 'pickleball-610x1341-h0';
    if (normalized.indexOf('tennis') !== -1) return 'tennis-1097x2377-h0';
    if (normalized.indexOf('padel') !== -1) return 'padel-1000x2000-h0';
    if (normalized.indexOf('volleyball') !== -1) return 'volleyball-900x1800-h0';
    if (normalized.indexOf('shuffleboard') !== -1) return 'shuffleboard-183x1585-h0';
    if (normalized.indexOf('futsal') !== -1) return 'futsal-2000x4000-h0';
    if (normalized.indexOf('netball') !== -1) return 'netball-1525x3050-h0';
    return null;
  }

  function deriveBuilderSports(payload) {
    const sports = [];
    const seen = Object.create(null);
    const add = function (value) {
      const normalized = normalizeBuilderSport(value);
      if (!normalized || seen[normalized]) return;
      seen[normalized] = true;
      sports.push(normalized);
    };

    add(payload.ruleset);
    add(payload.courtType);
    if (Array.isArray(payload.courts)) {
      payload.courts.forEach(function (court) {
        if (!court) return;
        add(court.ruleset);
        add(court.courtType);
        add(court.courtTypeLabel);
        if (court.extraSports && typeof court.extraSports === 'object') {
          Object.keys(court.extraSports).forEach(function (key) {
            const config = court.extraSports[key];
            if (config && config.enabled) add(key);
          });
        }
      });
    }

    if (payload.extraSports && typeof payload.extraSports === 'object') {
      Object.keys(payload.extraSports).forEach(function (key) {
        const config = payload.extraSports[key];
        if (config && config.enabled) {
          add(key);
        }
      });
    }

    return sports;
  }

  function deriveBuilderLines(payload) {
    const lines = [];
    const seen = Object.create(null);
    const add = function (value) {
      const text = String(value || '').trim();
      if (!text || seen[text]) return;
      seen[text] = true;
      lines.push(text.replace(/[-_]+/g, ' '));
    };

    add(payload.ruleset);
    if (Array.isArray(payload.courts)) {
      payload.courts.forEach(function (court) {
        if (!court) return;
        add(court.ruleset);
        if (court.extraSports && typeof court.extraSports === 'object') {
          Object.keys(court.extraSports).forEach(function (key) {
            const config = court.extraSports[key];
            if (config && config.enabled) add(key);
          });
        }
      });
    }

    if (payload.extraSports && typeof payload.extraSports === 'object') {
      Object.keys(payload.extraSports).forEach(function (key) {
        const config = payload.extraSports[key];
        if (config && config.enabled) {
          add(key);
        }
      });
    }

    return lines;
  }

  function collectBuilderRawFields(form) {
    const data = new FormData(form);
    const raw = Object.create(null);
    const FileCtor = (typeof File === 'function') ? File : null;
    data.forEach(function (value, name) {
      if (!/^contact\[/.test(name) || (FileCtor && value instanceof FileCtor)) return;
      const match = String(name).match(/^contact\[(.+)\]$/);
      const key = (match ? String(match[1]) : String(name))
        .trim()
        .toLowerCase()
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ');
      const text = sanitizeText(value);
      if (!text) return;
      if (!Object.prototype.hasOwnProperty.call(raw, key)) {
        raw[key] = text;
        return;
      }
      if (Array.isArray(raw[key])) {
        raw[key].push(text);
        return;
      }
      raw[key] = [raw[key], text];
    });
    return raw;
  }

  function getBuilderLocalization(root) {
    const globalLocalization = (typeof window !== 'undefined' && window.SWISH_SYSTEM_LOCALIZATION)
      ? window.SWISH_SYSTEM_LOCALIZATION
      : null;

    return {
      market: sanitizeText(
        (root && root.getAttribute && root.getAttribute('data-swish-market')) ||
        (globalLocalization && (globalLocalization.market || globalLocalization.marketName)) ||
        ''
      ),
      country: sanitizeText(
        (root && root.getAttribute && root.getAttribute('data-swish-country')) ||
        (globalLocalization && (globalLocalization.country || globalLocalization.countryCode)) ||
        ''
      ),
      countryCode: sanitizeText(
        (root && root.getAttribute && root.getAttribute('data-swish-country-code')) ||
        (globalLocalization && globalLocalization.countryCode) ||
        ''
      )
    };
  }

  function ensureMetadataField(form, selector, name, value) {
    const field = ensureField(form, selector, 'input', {
      id: selector.replace(/^#/, ''),
      type: 'hidden',
      name: name
    });
    setFieldSubmissionValue(field, value);
    return field;
  }

  function ensureBuilderMetadataFields(root, form, pageUrl, origin) {
    const localization = getBuilderLocalization(root);
    ensureMetadataField(form, '#swishcb-contact-source-website', 'contact[Source website]', origin || '');
    ensureMetadataField(form, '#swishcb-contact-source-page', 'contact[Source page]', pageUrl || '');
    ensureMetadataField(form, '#swishcb-contact-market', 'contact[Market]', localization.market);
    ensureMetadataField(form, '#swishcb-contact-country', 'contact[Country]', localization.country || localization.countryCode);
    ensureMetadataField(form, '#swishcb-contact-category', 'contact[Swish Category]', 'FLOORING');
    return localization;
  }

  async function submitBuilderIntake(root, form, payload, data) {
    const intake = (typeof window !== 'undefined') ? window.SwishSystemIntake : null;
    if (!intake || typeof intake.ensureIntakeIdField !== 'function' || typeof intake.postThemePayload !== 'function') {
      return {
        ok: false,
        skipped: true,
        reason: 'missing-intake'
      };
    }

    const intakeId = intake.ensureIntakeIdField(form);
    const localization = ensureBuilderMetadataFields(
      root,
      form,
      data.pageUrl || ((typeof window !== 'undefined' && window.location) ? window.location.href : ''),
      (typeof window !== 'undefined' && window.location) ? window.location.origin : ''
    );
    const rawFields = collectBuilderRawFields(form);
    const contactValues = data.contactValues || {};
    const firstName = sanitizeText(contactValues.firstName);
    const lastName = sanitizeText(contactValues.lastName);
    const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
    const logoUrls = Array.isArray(data.logoUrls) ? data.logoUrls.slice() : [];
    const isMultiCourt = String(payload.mode || payload.courtMode || '').toLowerCase() === 'multiple';
    const units = payload.units === 'ft' ? 'ft' : 'm';
    const builderWidth = Number.isFinite(payload.widthM)
      ? (units === 'ft' ? m2ft(payload.widthM) : payload.widthM)
      : null;
    const builderLength = Number.isFinite(payload.lengthM)
      ? (units === 'ft' ? m2ft(payload.lengthM) : payload.lengthM)
      : null;
    const contactWidth = parseNumericInput(contactValues.width);
    const contactLength = parseNumericInput(contactValues.length);
    const surfaceWidth = isMultiCourt
      ? builderWidth
      : ((Number.isFinite(contactWidth) && contactWidth > 0) ? contactWidth : builderWidth);
    const surfaceLength = isMultiCourt
      ? builderLength
      : ((Number.isFinite(contactLength) && contactLength > 0) ? contactLength : builderLength);

    return intake.postThemePayload(root, {
      intakeId: intakeId,
      source: 'BUILDER',
      formType: 'swish-court-builder',
      pageUrl: data.pageUrl || ((typeof window !== 'undefined' && window.location) ? window.location.href : null),
      origin: (typeof window !== 'undefined' && window.location) ? window.location.origin : null,
      geoCountry: localization.country || localization.countryCode || null,
      category: 'FLOORING',
      submittedAt: payload.timestamp || (new Date()).toISOString(),
      contact: {
        fullName: fullName || null,
        firstName: firstName || null,
        lastName: lastName || null,
        email: sanitizeText(contactValues.email) || null,
        phone: sanitizeText(contactValues.phone) || null,
        shippingAddress: sanitizeText(contactValues.shipping) || null,
        country: localization.country || localization.countryCode || null,
        company: null
      },
      court: {
        width: surfaceWidth,
        length: surfaceLength,
        units: units,
        officialDimensionKey: isMultiCourt ? null : mapRulesetToOfficialDimensionKey(payload.ruleset),
        courtType: isMultiCourt ? 'Multiple Courts' : (payload.courtType || null),
        sports: deriveBuilderSports(payload),
        lines: deriveBuilderLines(payload),
        notes: sanitizeText(contactValues.notes) || null,
        timeline: null,
        colors: {
          colors: payload.colors || null,
          detailColors: payload.detailColors || null,
          hiddenDetails: payload.hiddenDetails || [],
          detailVisibility: payload.detailVisibility || null
        },
        builderConfiguration: data.details || payload.config || payload.configRaw || null,
        previewUrl: data.design2dUrl || data.previewUrl || null,
        shareUrl: data.exactPreviewUrl || data.shareUrl || null
      },
      builder: {
        summary: data.summary || null,
        raw: data.details || payload.config || payload.configRaw || null,
        previewImageUrl: data.previewUrl || null,
        exactPreviewUrl: data.exactPreviewUrl || data.shareUrl || null,
        design2dUrl: data.design2dUrl || null,
        shareMedia: data.shareMedia || null,
        logoFiles: logoUrls
      },
      attachmentUrls: {
        previewImage: data.previewUrl || null,
        design2d: data.design2dUrl || null,
        logoFiles: logoUrls,
        uploads: [data.design2dUrl].filter(Boolean)
      },
      attachmentData: {
        previewImage: data.previewAttachment || null
      },
      rawFields: rawFields
    });
  }

  function readHoopSelectionFromDom(root) {
    if (!root) return null;
    const leftBox = root.querySelector('#swishcb-left-hoop');
    const rightBox = root.querySelector('#swishcb-right-hoop');
    const topBox = root.querySelector('#swishcb-top-hoop');
    const bottomBox = root.querySelector('#swishcb-bottom-hoop');
    if (!leftBox && !rightBox && !topBox && !bottomBox) return null;
    return {
      leftOn: !!(leftBox && leftBox.checked),
      rightOn: !!(rightBox && rightBox.checked),
      topOn: !!(topBox && topBox.checked),
      bottomOn: !!(bottomBox && bottomBox.checked)
    };
  }

  function readBorderSelectionFromDom(root, hoopSelection) {
    if (!root) return null;
    const hasSizeInputs = !!root.querySelector('#swishcb-left-border-size, #swishcb-right-border-size, #swishcb-top-border-size, #swishcb-bottom-border-size');
    if (!hasSizeInputs) return null;
    const borderSizePositive = (side) => {
      const input = root.querySelector(`#swishcb-${side}-border-size`);
      if (!input) return false;
      const value = parseNumericInput(input.value);
      return Number.isFinite(value) && value > 0;
    };
    return {
      leftOn: borderSizePositive('left'),
      rightOn: borderSizePositive('right'),
      topOn: borderSizePositive('top'),
      bottomOn: borderSizePositive('bottom')
    };
  }

  function readOverhangsFromDom(root, unit) {
    if (!root) return null;
    const leftInput = root.querySelector('#swishcb-left-hoop-distance');
    const rightInput = root.querySelector('#swishcb-right-hoop-distance');
    const topInput = root.querySelector('#swishcb-top-hoop-distance');
    const bottomInput = root.querySelector('#swishcb-bottom-hoop-distance');
    if (!leftInput && !rightInput && !topInput && !bottomInput) return null;
    const toMeters = (value) => {
      const num = parseNumericInput(value);
      if (!Number.isFinite(num)) return null;
      if (unit === 'ft') return num / 3.28084;
      return num / 100;
    };
    return {
      left: toMeters(leftInput && leftInput.value),
      right: toMeters(rightInput && rightInput.value),
      top: toMeters(topInput && topInput.value),
      bottom: toMeters(bottomInput && bottomInput.value)
    };
  }

  function readHoopsModeFromDom(root) {
    if (!root) return null;
    const select = root.querySelector('#swishcb-hoops-mode');
    return select ? select.value : null;
  }

  function buildSummary(payload, previewInfo, logoAttachInfo, contactValues, root) {
    const lines = [];
    const contact = contactValues || {};
    const unit = payload.units || 'm';
    const config = payload.config || null;
    const shareData = payload.shareData || null;
    const builderRoot = root || getRoot();
    const isMultiCourt = String(payload.mode || payload.courtMode || '').toLowerCase() === 'multiple';

    const resolveDimension = (raw, meters) => {
      const trimmed = String(raw || '').trim();
      if (trimmed) return trimmed;
      if (Number.isFinite(meters)) {
        const val = unit === 'ft' ? m2ft(meters) : meters;
        return fmt(val, 2);
      }
      return '';
    };
    const widthValue = resolveDimension(contact.width, payload.widthM);
    const lengthValue = resolveDimension(contact.length, payload.lengthM);
    const fullName = `${String(contact.firstName || '').trim()} ${String(contact.lastName || '').trim()}`.trim();

    const readSelectLabel = (selector) => {
      if (!builderRoot) return '';
      const select = builderRoot.querySelector(selector);
      if (!select || !select.options || select.selectedIndex < 0) return '';
      const option = select.options[select.selectedIndex];
      if (!option) return '';
      const value = String(option.value || '').trim();
      const isPlaceholder = option.dataset && option.dataset.placeholder === '1';
      if (isPlaceholder || !value) return '';
      const label = String(option.textContent || '').trim();
      return label || value;
    };
    const courtTypeLabel = isMultiCourt
      ? 'Multiple Courts'
      : (readSelectLabel('#court-xxx') || payload.courtType || (shareData && shareData.ct) || '-');
    const sizePresetLabel = readSelectLabel('#court-preset') || 'Custom';
    const colorPresetLabel = readSelectLabel('#color-preset') || 'Custom';
    const hoopPresetLabel = readSelectLabel('#swishcb-hoop-preset') || (payload.hoopModelPreset || 'Custom');

    const formatSelection = (sel) => {
      if (!sel) return '-';
      return `L ${sel.leftOn ? 'on' : 'off'} | R ${sel.rightOn ? 'on' : 'off'} | T ${sel.topOn ? 'on' : 'off'} | B ${sel.bottomOn ? 'on' : 'off'}`;
    };
    const formatView = () => {
      if (!payload.view) return '-';
      const mode = payload.view.mode ? String(payload.view.mode).toUpperCase() : '-';
      const zoom = payload.view.zoom ?? '-';
      const autoRotate = payload.view.autoRotate ? 'on' : 'off';
      return `${mode} (zoom ${zoom}, auto-rotate ${autoRotate})`;
    };
    const formatBuffers = (buf) => {
      if (!buf) return '-';
      return `L ${fmtDistanceByUnit(buf.left, unit)} | R ${fmtDistanceByUnit(buf.right, unit)} | T ${fmtDistanceByUnit(buf.top, unit)} | B ${fmtDistanceByUnit(buf.bottom, unit)}`;
    };
    const formatTileCounts = () => {
      const counts = payload.tileCounts || null;
      if (!counts) return '-';
      const series = payload.tileSeries || (payload.shareData && payload.shareData.ts) || '';
      return `L ${counts.length ?? '-'} x W ${counts.width ?? '-'}${series ? ` (${series})` : ''}`;
    };
    const formatMeasurements = () => {
      const measurements = payload.measurements && typeof payload.measurements === 'object'
        ? payload.measurements
        : null;
      if (!measurements) return '-';
      const order = ['total', 'keys', 'three', 'penalty', 'goal'];
      return order
        .filter((key) => Object.prototype.hasOwnProperty.call(measurements, key))
        .map((key) => `${key}:${measurements[key] ? 'on' : 'off'}`)
        .join(' | ') || '-';
    };
    const formatLineSize = () => {
      const selected = payload.nonBasketballLineSizeMode || '-';
      const effective = payload.nonBasketballLineSizeEffectiveMode || '-';
      const geom = payload.nonBasketballLineSizeGeometry || null;
      const target = geom && Number.isFinite(Number(geom.targetLengthM)) && Number.isFinite(Number(geom.targetWidthM))
        ? ` | target L ${fmtDistanceByUnit(Number(geom.targetLengthM), unit)} x W ${fmtDistanceByUnit(Number(geom.targetWidthM), unit)}`
        : '';
      return `${selected} / effective ${effective}${target}`;
    };
    const formatHoopPoleBuffer = (buf) => {
      if (!buf) return '-';
      return `L ${fmtDistanceByUnit(buf.left, unit)} | R ${fmtDistanceByUnit(buf.right, unit)}`;
    };
    const formatOverhangs = (overhangs) => {
      if (!overhangs) return '-';
      return `L ${fmtDistanceByUnit(overhangs.left, unit)} | R ${fmtDistanceByUnit(overhangs.right, unit)} | T ${fmtDistanceByUnit(overhangs.top, unit)} | B ${fmtDistanceByUnit(overhangs.bottom, unit)}`;
    };
    const formatKeyDimensions = (keyDims) => {
      if (!keyDims) return '-';
      const length = fmtDistanceByUnit(keyDims.length, unit);
      const width = fmtDistanceByUnit(keyDims.width, unit);
      const mode = keyDims.manual ? 'custom' : 'default';
      const ftRadius = Number.isFinite(Number(keyDims.freeThrowHalfCircleRadiusM))
        ? ` | free-throw half-circle R ${fmtDistanceByUnit(keyDims.freeThrowHalfCircleRadiusM, unit)}`
        : '';
      return `L ${length} x W ${width} (${mode})${ftRadius}`;
    };
    const formatThreePointDistance = () => {
      const source = payload.threePointDistance && typeof payload.threePointDistance === 'object'
        ? payload.threePointDistance
        : null;
      const distance = source && Number.isFinite(Number(source.displayedM))
        ? Number(source.displayedM)
        : (Number.isFinite(Number(payload.threePointDistanceM)) ? Number(payload.threePointDistanceM) : null);
      if (!Number.isFinite(distance)) return null;
      const mode = source && source.manual ? 'custom' : 'default';
      return `${fmtDistanceByUnit(distance, unit)} (${mode})`;
    };
    const formatGoalPostRadius = () => {
      const source = payload.netballGoalPostM && typeof payload.netballGoalPostM === 'object'
        ? payload.netballGoalPostM
        : null;
      const radius = source && Number.isFinite(source.radius)
        ? source.radius
        : (Number.isFinite(payload.goalPostRadiusM) ? payload.goalPostRadiusM : null);
      if (!Number.isFinite(radius)) return null;
      const mode = source && source.manual ? 'custom' : 'default';
      return `${fmtDistanceByUnit(radius, unit)} (${mode})`;
    };
    const formatExtraSportsLines = () => {
      const entries = (payload.extraSports && typeof payload.extraSports === 'object') ? payload.extraSports : {};
      const order = ['fiba3', 'nba3', 'ncaa3', 'usahs3', 'tennis', 'pickleball', 'padel', 'volleyball', 'shuffleboard', 'cornhole', 'futsal', 'netball'];
      const extraIds = Array.from(new Set(order.concat(Object.keys(entries))));
      return extraIds.map((id) => {
        const entry = entries[id] || {};
        const label = formatExtraIdForDisplay(id);
        const enabled = !!entry.enabled;
        if (!enabled) return `  - ${label}: off`;
        const color = entry.color ? String(entry.color).toLowerCase() : '-';
        const scaleValue = Number(entry.scale);
        const rotationValue = Number(entry.rotation);
        const offsetXValue = Number(entry.offsetX);
        const offsetYValue = Number(entry.offsetY);
        const scale = Number.isFinite(scaleValue) ? fmtTrim(scaleValue, 2) : '-';
        if (Number.isFinite(rotationValue)) entry.rotation = rotationValue;
        const rotation = Number.isFinite(entry.rotation) ? `${Math.round(entry.rotation)}°` : '-';
        const offsetX = Number.isFinite(offsetXValue) ? fmtDistanceByUnit(offsetXValue, unit) : '-';
        const offsetY = Number.isFinite(offsetYValue) ? fmtDistanceByUnit(offsetYValue, unit) : '-';
        return `  - ${label}: on | color ${color} | scale ${scale} | rot ${rotation} | offset (${offsetX}, ${offsetY})`;
      });
    };
    const readTextField = (entry, keys) => {
      if (!entry || typeof entry !== 'object') return '';
      for (let index = 0; index < keys.length; index += 1) {
        const key = keys[index];
        if (entry[key] != null && String(entry[key]).trim()) return entry[key];
      }
      return '';
    };
    const getTextEntriesForSummary = () => {
      const sources = [
        Array.isArray(payload.texts) ? payload.texts : [],
        config && Array.isArray(config.texts) ? config.texts : [],
        shareData && Array.isArray(shareData.txt) ? shareData.txt : []
      ];
      const source = sources.find((entries) => entries && entries.length) || [];
      return source.filter((entry) => String(readTextField(entry, ['text', 't']) || '').trim());
    };
    const formatTextSummaryLine = (entry, idx) => {
      const label = String(readTextField(entry, ['label']) || `Text ${idx + 1}`).trim();
      const rawText = String(readTextField(entry, ['text', 't']) || '').replace(/\s+/g, ' ').trim();
      const displayText = rawText.length > 70 ? `${rawText.slice(0, 67)}...` : rawText;
      const font = normalizeValue(readTextField(entry, ['font', 'f']));
      const fontColor = normalizeValue(readTextField(entry, ['color', 'c']), '#000000');
      const strokeColor = normalizeValue(readTextField(entry, ['strokeColor', 'sc', 'outlineColor', 'oc']), '#000000');
      const strokeRaw = Number(readTextField(entry, ['strokeSize', 'ss', 'os']));
      const xRaw = Number(readTextField(entry, ['x']));
      const yRaw = Number(readTextField(entry, ['y']));
      const scaleRaw = Number(readTextField(entry, ['scale', 's']));
      const rotationRaw = Number(readTextField(entry, ['rotation', 'r']));
      const strokeSize = Number.isFinite(strokeRaw) ? `${fmtTrim(strokeRaw, 2)}%` : '-';
      const x = Number.isFinite(xRaw) ? fmtDistanceByUnit(xRaw, unit) : '-';
      const y = Number.isFinite(yRaw) ? fmtDistanceByUnit(yRaw, unit) : '-';
      const scale = Number.isFinite(scaleRaw) ? `${fmtTrim(scaleRaw * 100, 1)}%` : '-';
      const rotation = Number.isFinite(rotationRaw) ? `${fmtTrim(rotationRaw, 1)} deg` : '-';
      const customFontName = String(readTextField(entry, ['customFontName', 'fontName', 'cn']) || '').trim();
      const customFontFile = String(readTextField(entry, ['customFontFileName', 'fontFileName', 'fn']) || '').trim();
      const customFont = customFontName || customFontFile
        ? ` | custom font ${normalizeValue([customFontName, customFontFile].filter(Boolean).join(' / '))}`
        : '';
      return `  - ${label}: "${displayText}" | font ${font} | font color ${fontColor} | stroke ${strokeColor} ${strokeSize} | pos (${x}, ${y}) | scale ${scale} | rot ${rotation}${customFont}`;
    };

    lines.push('Submission Summary:');
    lines.push('Customer info');
    lines.push(`- Court width: ${normalizeValue(widthValue)}`);
    lines.push(`- Court length: ${normalizeValue(lengthValue)}`);
    lines.push(`- Name: ${normalizeValue(fullName)}`);
    lines.push(`- Email: ${normalizeValue(contact.email)}`);
    lines.push(`- Phone: ${normalizeValue(contact.phone)}`);
    lines.push(`- Shipping address: ${normalizeValue(contact.shipping)}`);
    lines.push(`- Notes: ${normalizeValue(contact.notes)}`);
    lines.push(`- Receive samples: ${normalizeValue(contact.receiveSamples)}`);

    lines.push('');
    lines.push('Court info');
    lines.push(`- Court type: ${normalizeValue(courtTypeLabel)}`);
    lines.push(`- Ruleset: ${normalizeValue(payload.ruleset || (config && config.ruleset))}`);
    lines.push(`- Size preset: ${normalizeValue(sizePresetLabel)}`);
    lines.push(`- Units: ${normalizeValue(payload.units)}`);
    lines.push(`- Footprint: L ${fmtMetersFeet(payload.lengthM)} x W ${fmtMetersFeet(payload.widthM)}`);
    lines.push(`- Line size: ${formatLineSize()}`);
    lines.push(`- Tile counts: ${formatTileCounts()}`);
    lines.push(`- Measurements: ${formatMeasurements()}`);
    if (isMultiCourt && Array.isArray(payload.courts)) {
      lines.push('- Court mode: Multiple Courts');
      lines.push(`- Courts: ${payload.courts.length}`);
      payload.courts.forEach((court, idx) => {
        const label = court && (court.courtTypeLabel || court.courtType || court.ruleset)
          ? (court.courtTypeLabel || court.courtType || court.ruleset)
          : 'Court';
        const length = fmtDistanceByUnit(court && Number(court.lengthM), unit);
        const width = fmtDistanceByUnit(court && Number(court.widthM), unit);
        const x = fmtDistanceByUnit(court && Number(court.xM), unit);
        const y = fmtDistanceByUnit(court && Number(court.yM), unit);
        const selected = court && court.selected ? ' | selected' : '';
        const threePoint = Number.isFinite(Number(court && court.threePointDistanceM))
          ? ` | 3PT ${fmtDistanceByUnit(Number(court.threePointDistanceM), unit)}`
          : '';
        lines.push(`  - Court ${court && court.number ? court.number : idx + 1}: ${label} | L ${length} x W ${width} | pos (${x}, ${y})${threePoint}${selected}`);
      });
    }
    if (config && config.playableBox) {
      const pl = config.playableBox.length_m;
      const pw = config.playableBox.width_m;
      lines.push(`- Playable: L ${fmtMetersFeet(pl)} x W ${fmtMetersFeet(pw)}`);
    }
    if (config && config.buffers_m) {
      lines.push(`- Buffers: ${formatBuffers(config.buffers_m)}`);
    }
    if (config && config.hoopPoleBuffer_m) {
      lines.push(`- Hoop pole buffer: ${formatHoopPoleBuffer(config.hoopPoleBuffer_m)}`);
    }
    lines.push(`- Rotation: ${Number.isFinite(payload.rotation) ? `${Math.round(payload.rotation)}°` : '-'}`);
    lines.push(`- Hoops: ${fmtHoopsMode(payload.hoopsMode)}`);
    lines.push(`- Hoop selection: ${formatSelection(payload.hoopSelection)}`);
    lines.push(`- Border boxes: ${formatSelection(payload.borderSelection)}`);
    lines.push(`- Border sizes: ${formatBuffers(payload.borderSizesM)}`);
    lines.push(`- Overhangs: ${formatOverhangs(payload.hoopOverhangsM)}`);
    const goalPostRadius = formatGoalPostRadius();
    if (goalPostRadius) {
      lines.push(`- Goal Post radius: ${goalPostRadius}`);
    } else {
      lines.push(`- Key dimensions: ${formatKeyDimensions(payload.keyDimensionsM)}`);
      lines.push(`- Key/match mode: ${normalizeValue(payload.keyDimensionsM && payload.keyDimensionsM.mode || payload.shareData && payload.shareData.kta)}`);
      const threePointDistance = formatThreePointDistance();
      if (threePointDistance) lines.push(`- 3-Point distance: ${threePointDistance}`);
    }
    lines.push(`- Hoop preset: ${normalizeValue(hoopPresetLabel, 'Custom')}`);
    lines.push(`- View: ${formatView()}`);

    lines.push('');
    lines.push('Extra sports');
    lines.push('- Extra sports:');
    lines.push(...formatExtraSportsLines());

    lines.push('');
    lines.push('Colors');
    lines.push(`- Colour preset: ${normalizeValue(colorPresetLabel)}`);
    lines.push(`- Main: ${payload.colors && payload.colors.main ? payload.colors.main : '-'}`);
    lines.push(`- Key: ${payload.colors && payload.colors.key ? payload.colors.key : '-'}`);
    lines.push(`- Lines: ${payload.colors && payload.colors.lines ? payload.colors.lines : '-'}`);
    lines.push(`- Border: ${payload.colors && payload.colors.border ? payload.colors.border : '-'}`);
    lines.push(`- Edge: ${payload.colors && payload.colors.edge ? payload.colors.edge : '-'}`);
    lines.push(`- Detail colors: ${fmtKeyValueList(payload.detailColors)}`);
    lines.push(`- Detail visibility: ${fmtVisibilityOverrides(payload.detailVisibility)}`);
    lines.push(`- Hidden detail ids: ${fmtHiddenList(payload.hiddenDetails)}`);

    lines.push('');
    lines.push('Logos');
    if (Array.isArray(payload.logos) && payload.logos.length) {
      lines.push(`- Logos: ${payload.logos.length}`);
      payload.logos.forEach((logo, idx) => {
        const logoUnit = payload.logoUnit || unit || 'm';
        const w = fmtDistanceByUnit(logo.widthM, logoUnit);
        const h = fmtDistanceByUnit(logo.heightM, logoUnit);
        const x = fmtDistanceByUnit(logo.x, logoUnit);
        const y = fmtDistanceByUnit(logo.y, logoUnit);
        const scale = Number.isFinite(logo.scale) ? fmtTrim(logo.scale, 2) : '-';
        const rotation = Number.isFinite(logo.rotation) ? `${Math.round(logo.rotation)}°` : '-';
        const fileType = logo.fileType || '-';
        const fileSize = fmtBytes(logo.fileSize);
        lines.push(`  - Logo ${idx + 1}: ${logo.fileName || logo.label || 'Logo'} | ${w} x ${h} | pos (${x}, ${y}) | scale ${scale} | rot ${rotation} | bg ${logo.removeBgMode || 'none'} | file ${fileType} ${fileSize}`);
      });
    } else {
      lines.push('- Logos: none');
    }
    lines.push(`- Logo attachments: ${logoAttachInfo && logoAttachInfo.summary ? logoAttachInfo.summary : 'none'}`);

    lines.push('');
    lines.push('Text');
    const textEntries = getTextEntriesForSummary();
    if (textEntries.length) {
      lines.push(`- Text elements: ${textEntries.length}`);
      textEntries.forEach((entry, idx) => {
        lines.push(formatTextSummaryLine(entry, idx));
      });
    } else {
      lines.push('- Text elements: none');
    }

    lines.push('');
    lines.push('Links & preview');
    lines.push(`- Share URL: ${normalizeValue(payload.shareUrl)}`);
    lines.push(`- Page URL: ${normalizeValue(payload.pageUrl)}`);
    lines.push(`- Preview image: ${previewInfo && previewInfo.summary ? previewInfo.summary : 'not included'}`);

    if (logoAttachInfo && Array.isArray(logoAttachInfo.accepted) && logoAttachInfo.accepted.length) {
      lines.push(`- Logo files attached: ${logoAttachInfo.accepted.join(', ')}`);
    }
    if (logoAttachInfo && Array.isArray(logoAttachInfo.skipped) && logoAttachInfo.skipped.length) {
      lines.push(`- Logo files skipped: ${logoAttachInfo.skipped.join(', ')}`);
    }
    return lines.join('\n');
  }

  async function pickPreview(api) {
    if (!api || typeof api.getSnapshotData !== 'function') return null;
    const attempts = [
      {
        maxWidth: 760,
        maxHeight: 430,
        renderWidth: 760,
        renderHeight: 430,
        renderAtMaxSize: true,
        quality: 0.92,
        type: 'image/png',
        noRotation: true,
        whiteBg: true,
        saveStyle: true,
        includeDataUrl: false
      },
      {
        maxWidth: 520,
        maxHeight: 300,
        renderWidth: 520,
        renderHeight: 300,
        renderAtMaxSize: true,
        quality: 0.92,
        type: 'image/png',
        noRotation: true,
        whiteBg: true,
        saveStyle: true,
        includeDataUrl: false
      }
    ];
    let best = null;
    for (const attempt of attempts) {
      const result = await api.getSnapshotData(attempt);
      if (!result) continue;
      best = result;
      if (result.blob && result.blob.size <= MAX_PREVIEW_BYTES) return result;
    }
    return best;
  }

  function buildInlinePreviewAttachment(blob) {
    if (!blob || !Number.isFinite(blob.size) || blob.size <= 0 || blob.size > MAX_PREVIEW_BYTES) {
      return Promise.resolve(null);
    }
    const contentType = String(blob.type || 'image/png').toLowerCase();
    if (!['image/png', 'image/jpeg', 'image/webp'].includes(contentType) || typeof FileReader !== 'function') {
      return Promise.resolve(null);
    }

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onerror = () => resolve(null);
      reader.onload = () => {
        const dataUrl = typeof reader.result === 'string' ? reader.result : '';
        const commaIndex = dataUrl.indexOf(',');
        const base64 = commaIndex >= 0 ? dataUrl.slice(commaIndex + 1).replace(/\s+/g, '') : '';
        if (!base64 || !/^[A-Za-z0-9+/]+={0,2}$/.test(base64)) {
          resolve(null);
          return;
        }
        resolve({
          fileName: contentType === 'image/jpeg' ? 'swish-court-preview.jpg' : contentType === 'image/webp' ? 'swish-court-preview.webp' : 'swish-court-preview.png',
          contentType: contentType,
          base64: base64,
          bytes: blob.size
        });
      };
      reader.readAsDataURL(blob);
    });
  }

  async function pickPreviewData(api) {
    if (!api || typeof api.getSnapshotData !== 'function') return null;
    const attempts = [
      {
        maxWidth: 420,
        maxHeight: 240,
        renderWidth: 420,
        renderHeight: 240,
        renderAtMaxSize: true,
        quality: 0.92,
        type: 'image/png',
        noRotation: true,
        whiteBg: true,
        saveStyle: true,
        includeBlob: false
      },
      {
        maxWidth: 280,
        maxHeight: 160,
        renderWidth: 280,
        renderHeight: 160,
        renderAtMaxSize: true,
        quality: 0.92,
        type: 'image/png',
        noRotation: true,
        whiteBg: true,
        saveStyle: true,
        includeBlob: false
      }
    ];
    let best = null;
    for (const attempt of attempts) {
      const result = await api.getSnapshotData(attempt);
      if (!result) continue;
      best = result;
      if (result.dataUrl && result.dataUrl.length <= MAX_PREVIEW_DATA_CHARS) return result;
    }
    return best;
  }

  function attachFiles(input, files) {
    if (!input || !files || !files.length) return false;
    try {
      const wasDisabled = !!input.disabled;
      if (wasDisabled) input.disabled = false;
      const dt = new DataTransfer();
      files.forEach((file) => dt.items.add(file));
      input.files = dt.files;
      const attached = !!(input.files && input.files.length > 0);
      if (wasDisabled && !attached) input.disabled = true;
      return attached;
    } catch (_) {
      return false;
    }
  }

  async function handleSubmit(form, api, root, debugSession) {
    if (form.dataset.swishcbContactSubmitting === '1') {
      return { submitted: false, reason: 'busy' };
    }
    if (!form.checkValidity()) {
      try { form.reportValidity(); } catch (_) {}
      return { submitted: false, reason: 'invalid' };
    }
    form.dataset.swishcbContactSubmitting = '1';

    try {
      const payload = buildPayload(api, form, root);
      if (debugSession) debugSession.mark('payload-built');

      const submissionNotes = [];
      const bodyField = ensureHiddenTextarea(form, '#swishcb-contact-body', {
        id: 'swishcb-contact-body',
        name: 'contact[body]',
        hidden: ''
      });
      const summaryField = ensureHiddenTextarea(form, '#swishcb-contact-summary', {
        id: 'swishcb-contact-summary',
        name: 'contact[Court Summary]',
        hidden: ''
      });
      const detailsField = ensureHiddenTextarea(form, '#swishcb-contact-details', {
        id: 'swishcb-contact-details',
        name: 'contact[Court Details JSON]',
        hidden: ''
      });
      const previewUploadField = ensureHiddenTextarea(form, '#swishcb-contact-preview-upload', {
        id: 'swishcb-contact-preview-upload',
        name: 'contact[2D Preview Image]',
        hidden: ''
      });
      const logoUploadField = ensureHiddenTextarea(form, '#swishcb-contact-logo-upload', {
        id: 'swishcb-contact-logo-upload',
        name: 'contact[Logo Files]',
        hidden: ''
      });
      const pageUrlField = ensureField(form, '#swishcb-contact-page-url', 'input', {
        id: 'swishcb-contact-page-url',
        type: 'hidden',
        name: 'contact[Page URL]'
      });
      const shareUrlField = ensureField(form, '#swishcb-contact-share-url', 'input', {
        id: 'swishcb-contact-share-url',
        type: 'hidden',
        name: 'contact[Share URL]'
      });
      const exactPreviewUrlField = ensureField(form, '#swishcb-contact-exact-preview-url', 'input', {
        id: 'swishcb-contact-exact-preview-url',
        type: 'hidden',
        name: 'contact[Exact Preview URL]'
      });
      const design2dUrlField = ensureField(form, '#swishcb-contact-design-2d-url', 'input', {
        id: 'swishcb-contact-design-2d-url',
        type: 'hidden',
        name: 'contact[2D Design Image]'
      });
      const configField = form.querySelector('#swishcb-contact-config');
      const previewUrlField = form.querySelector('#swishcb-contact-preview');
      const previewDataField = form.querySelector('#swishcb-contact-preview-data');
      const previewFileInput = form.querySelector('#swishcb-contact-preview-file');
      const logoInput = form.querySelector('#swishcb-contact-logo-files');
      const uploadEndpoint = buildUploadEndpoint();

      resetGeneratedField(previewUploadField);
      resetGeneratedField(logoUploadField);
      if (previewDataField) {
        setFieldValue(previewDataField, '');
        previewDataField.disabled = true;
      }
      clearFileInput(previewFileInput);
      clearFileInput(logoInput);
      if (debugSession) {
        debugSession.mark('upload-endpoint-ready', {
          available: !!uploadEndpoint
        });
      }

      const preview = await pickPreview(api);
      const previewAttachment = await buildInlinePreviewAttachment(preview && preview.blob);
      if (debugSession) {
        debugSession.mark('preview-picked', {
          available: !!(preview && preview.blob),
          bytes: preview && preview.blob ? preview.blob.size : null,
          attachedDirectly: !!previewAttachment
        });
      }
      let previewUploadedUrl = '';
      let previewUploadReason = '';
      if (preview && preview.blob) {
        if (preview.blob.size > MAX_PREVIEW_BYTES) {
          previewUploadReason = `preview exceeded ${fmtBytes(MAX_PREVIEW_BYTES)}`;
          appendSubmissionNote(
            submissionNotes,
            `The generated 2D preview image was omitted because it exceeded ${fmtBytes(MAX_PREVIEW_BYTES)}.`
          );
        } else if (!uploadEndpoint) {
          previewUploadReason = previewAttachment ? 'attached directly' : 'upload unavailable';
          if (!previewAttachment) {
            appendSubmissionNote(
              submissionNotes,
              'The generated court preview image was omitted because file uploads are unavailable on this page.'
            );
          }
        } else {
          setStatusMessage(form, 'Uploading preview image...', false);
          try {
            previewUploadedUrl = await uploadFile(
              uploadEndpoint,
              preview.blob,
              'swish-court-preview.png'
            );
          } catch (error) {
            previewUploadReason = previewAttachment ? 'attached directly after upload failure' : 'upload failed';
            if (!previewAttachment) {
              appendSubmissionNote(
                submissionNotes,
                `The generated court preview image could not be uploaded: ${(error && error.message) || 'Upload failed.'}`
              );
            }
          }
        }
      }
      const submittedPreviewUrl = omitOversizedValue(
        previewUploadedUrl,
        MAX_CONTACT_SHARE_URL_CHARS,
        'Preview URL',
        submissionNotes
      );
      setFieldSubmissionValue(previewUploadField, submittedPreviewUrl);
      if (debugSession) {
        debugSession.mark('preview-upload-processed', {
          uploaded: !!submittedPreviewUrl,
          reason: previewUploadReason || null
        });
      }

      const logoFiles = Array.isArray(payload.logoFiles) ? payload.logoFiles : [];
      const acceptedLogos = [];
      const skippedLogos = [];
      const uploadedLogoLines = [];
      let totalLogoBytes = 0;
      const previewBytes = preview && preview.blob ? Math.min(preview.blob.size, MAX_PREVIEW_BYTES) : 0;
      const logoBudget = Math.max(0, Math.min(MAX_TOTAL_LOGO_BYTES, MAX_TOTAL_ATTACHMENT_BYTES - previewBytes));
      const FileCtor = (typeof File === 'function') ? File : null;
      logoFiles.forEach((file) => {
        if (!file || (FileCtor && !(file instanceof FileCtor))) return;
        if (file.size > MAX_LOGO_FILE_BYTES) {
          skippedLogos.push(`${file.name} (too large)`);
          return;
        }
        if (totalLogoBytes + file.size > logoBudget) {
          skippedLogos.push(`${file.name} (total limit)`);
          return;
        }
        acceptedLogos.push(file);
        totalLogoBytes += file.size;
      });

      if (acceptedLogos.length && !uploadEndpoint) {
        appendSubmissionNote(
          submissionNotes,
          'Logo files were omitted because file uploads are unavailable on this page.'
        );
        acceptedLogos.forEach((file) => skippedLogos.push(`${file.name} (upload unavailable)`));
      } else {
        for (let index = 0; index < acceptedLogos.length; index += 1) {
          const file = acceptedLogos[index];
          setStatusMessage(form, `Uploading logo files (${index + 1}/${acceptedLogos.length})...`, false);
          try {
            const uploadedUrl = await uploadFile(uploadEndpoint, file, file.name || `logo-${index + 1}.bin`);
            uploadedLogoLines.push(`${file.name}: ${uploadedUrl}`);
          } catch (error) {
            skippedLogos.push(`${file.name} (upload failed)`);
            appendSubmissionNote(
              submissionNotes,
              `Logo file "${file.name}" could not be uploaded: ${(error && error.message) || 'Upload failed.'}`
            );
          }
        }
      }

      const submittedLogoLines = trimTextForField(
        uploadedLogoLines.join('\n'),
        MAX_CONTACT_UPLOAD_FIELD_CHARS,
        'Logo Files'
      );
      setFieldSubmissionValue(logoUploadField, submittedLogoLines);
      if (debugSession) {
        debugSession.mark('logos-processed', {
          uploaded: uploadedLogoLines.length,
          skipped: skippedLogos.length
        });
      }

      const previewInfo = {
        summary: submittedPreviewUrl
          ? `uploaded (${Math.round(((preview && preview.blob && preview.blob.size) || 0) / 1024)} KB)`
          : (previewUploadReason ? `omitted (${previewUploadReason})` : 'not included'),
        width: preview ? preview.width : null,
        height: preview ? preview.height : null,
        type: preview ? preview.type : null,
        bytes: preview && preview.blob ? preview.blob.size : null
      };

      const logoAttachInfo = {
        summary: uploadedLogoLines.length
          ? `${uploadedLogoLines.length} uploaded${skippedLogos.length ? `, ${skippedLogos.length} skipped` : ''}`
          : (acceptedLogos.length ? `0 uploaded, ${skippedLogos.length || acceptedLogos.length} skipped` : 'none'),
        accepted: uploadedLogoLines.map((line) => line.split(': ')[0]),
        skipped: skippedLogos
      };

      const shareMediaInfo = await prepareInquiryShareMedia(
        api,
        uploadEndpoint,
        form,
        submissionNotes,
        debugSession
      );
      const design2dUrl = shareMediaInfo && shareMediaInfo.design2d
        ? String(shareMediaInfo.design2d.publicUrl || shareMediaInfo.design2d.uploadedUrl || '').trim()
        : '';
      if (shareMediaInfo && shareMediaInfo.exactPreviewUrl) {
        payload.shareUrl = shareMediaInfo.exactPreviewUrl;
      }
      if (shareMediaInfo && shareMediaInfo.shareHash) {
        payload.shareHash = shareMediaInfo.shareHash;
      }
      if (shareMediaInfo && shareMediaInfo.shareData) {
        payload.shareData = shareMediaInfo.shareData;
      }
      if (shareMediaInfo && shareMediaInfo.logoManifestUrl) {
        payload.logoManifestUrl = shareMediaInfo.logoManifestUrl;
      }

      const submittedPageUrl = omitOversizedValue(
        getCanonicalPageUrl(payload.pageUrl),
        MAX_CONTACT_PAGE_URL_CHARS,
        'Page URL',
        submissionNotes
      ) || getCanonicalPageUrl();
      const submittedExactPreviewUrl = omitOversizedValue(
        (shareMediaInfo && shareMediaInfo.exactPreviewUrl) || payload.shareUrl,
        MAX_CONTACT_SHARE_URL_CHARS,
        'Exact Preview URL',
        submissionNotes
      );
      const submittedShareUrl = omitOversizedValue(
        submittedExactPreviewUrl || payload.shareUrl,
        MAX_CONTACT_SHARE_URL_CHARS,
        'Share URL',
        submissionNotes
      );
      const submittedDesign2dUrl = omitOversizedValue(
        design2dUrl,
        MAX_CONTACT_SHARE_URL_CHARS,
        '2D Design Image',
        submissionNotes
      );
      const submittedConfig = omitOversizedValue(
        payload.configRaw,
        MAX_CONTACT_CONFIG_CHARS,
        'Court Config',
        submissionNotes
      );

      setFieldSubmissionValue(pageUrlField, submittedPageUrl);
      setFieldSubmissionValue(shareUrlField, submittedShareUrl);
      setFieldSubmissionValue(exactPreviewUrlField, submittedExactPreviewUrl || submittedShareUrl);
      setFieldSubmissionValue(design2dUrlField, submittedDesign2dUrl);
      setFieldSubmissionValue(previewUrlField, submittedPreviewUrl);
      setFieldSubmissionValue(configField, submittedConfig);

      if (payload.units) {
        const unitRadio = form.querySelector(`input[name="swishcb-contact-units"][value="${payload.units}"]`);
        if (unitRadio) unitRadio.checked = true;
      }

      const contactValues = {
        width: readFormValue(form, '#swishcb-contact-width'),
        length: readFormValue(form, '#swishcb-contact-length'),
        shipping: readFormValue(form, '#swishcb-contact-address'),
        firstName: readFormValue(form, '#swishcb-contact-first'),
        lastName: readFormValue(form, '#swishcb-contact-last'),
        email: readFormValue(form, '#swishcb-contact-email'),
        phone: readFormValue(form, '#swishcb-contact-phone'),
        notes: readFormValue(form, '#swishcb-contact-notes'),
        receiveSamples: fmtYesNo(readFormCheckbox(form, '#swishcb-contact-samples'))
      };
      const standardNameField = ensureField(form, '#swishcb-contact-name', 'input', {
        id: 'swishcb-contact-name',
        type: 'hidden',
        name: 'contact[name]'
      });
      const standardPhoneField = ensureField(form, '#swishcb-contact-phone-standard', 'input', {
        id: 'swishcb-contact-phone-standard',
        type: 'hidden',
        name: 'contact[phone]'
      });
      setFieldSubmissionValue(
        standardNameField,
        [contactValues.firstName, contactValues.lastName].filter(Boolean).join(' ').trim()
      );
      setFieldSubmissionValue(standardPhoneField, contactValues.phone);
      const uploadedLogoUrls = uploadedLogoLines
        .map(function (line) {
          const parts = String(line).split(': ');
          return parts.length > 1 ? parts.slice(1).join(': ').trim() : '';
        })
        .filter(Boolean);
      const fullBuilderPayload = buildFullBuilderPayload(payload, {
        uploadedLogoUrls,
        previewUrl: submittedPreviewUrl,
        design2dUrl: submittedDesign2dUrl,
        exactPreviewUrl: submittedExactPreviewUrl || submittedShareUrl
      });
      const settingsIndex = buildSettingsIndex(fullBuilderPayload);
      const details = {
        schema: 'swish-court-builder-contact-details',
        schemaVersion: 2,
        completeness: {
          fullCanonicalPayloadIncluded: true,
          settingsIndexIncluded: true,
          shopifyFieldMayBeLong: true,
          binaryLogoFilesRepresentedAsMetadata: true
        },
        timestamp: payload.timestamp || null,
        pageUrl: payload.pageUrl || submittedPageUrl || null,
        submittedPageUrl: submittedPageUrl || null,
        shareUrl: payload.shareUrl || submittedShareUrl || null,
        submittedShareUrl: submittedShareUrl || null,
        exactPreviewUrl: submittedExactPreviewUrl || submittedShareUrl || null,
        shareHash: payload.shareHash || null,
        shareData: payload.shareData || null,
        settingsIndex,
        fullBuilderPayload,
        courtType: payload.courtType || null,
        ruleset: payload.ruleset || null,
        mode: payload.mode || payload.courtMode || 'single',
        selectedCourtId: payload.selectedCourtId || null,
        totalSurfaceM: payload.totalSurfaceM || null,
        courts: Array.isArray(payload.courts) ? payload.courts : [],
        units: payload.units || null,
        lengthM: payload.lengthM ?? null,
        widthM: payload.widthM ?? null,
        rotation: payload.rotation ?? null,
        measurements: payload.measurements || null,
        nonBasketballLineSizeMode: payload.nonBasketballLineSizeMode || null,
        nonBasketballLineSizeEffectiveMode: payload.nonBasketballLineSizeEffectiveMode || null,
        nonBasketballLineSizeGeometry: payload.nonBasketballLineSizeGeometry || null,
        tilesEnabled: payload.tilesEnabled ?? null,
        tileSeries: payload.tileSeries || (payload.shareData && payload.shareData.ts) || null,
        tileEdges: payload.tileEdges || null,
        tileEdgeMask: payload.tileEdgeMask ?? null,
        tileEdgeSizeM: payload.tileEdgeSizeM ?? null,
        tileCounts: payload.tileCounts || null,
        tileFootprintM: payload.tileFootprintM || null,
        tileMaterialCounts: payload.tileMaterialCounts || null,
        tileMaterialOwnership: payload.tileMaterialOwnership || null,
        installedSurfaceM: payload.installedSurfaceM || null,
        edgeColors: payload.edgeColors || null,
        colors: payload.colors || null,
        detailColors: payload.detailColors || null,
        hiddenDetails: payload.hiddenDetails || [],
        detailVisibility: payload.detailVisibility || null,
        extraSports: payload.extraSports || null,
        hoopOverhangsM: payload.hoopOverhangsM || null,
        hoopOverhangEditedSides: payload.hoopOverhangEditedSides || [],
        keyTileAlignment: payload.keyTileAlignment || (payload.shareData && payload.shareData.kta) || null,
        overlayKeysLinkedToBase: payload.overlayKeysLinkedToBase ?? null,
        keyDimensionsM: payload.keyDimensionsM || null,
        keyDimensionsDisplay: payload.keyDimensionsDisplay || null,
        centerCircleDiameterM: payload.centerCircleDiameterM ?? null,
        centerCircleDiameter: payload.centerCircleDiameter || null,
        centerCircleDiameterDisplay: payload.centerCircleDiameterDisplay || null,
        threePointDistanceM: payload.threePointDistanceM ?? null,
        threePointDistance: payload.threePointDistance || null,
        threePointDistanceDisplay: payload.threePointDistanceDisplay || null,
        futsalMode: payload.futsalMode || null,
        futsalPlayingAreaM: payload.futsalPlayingAreaM || null,
        futsalPenaltyAreaM: payload.futsalPenaltyAreaM || null,
        futsalPlayingAreaDisplay: payload.futsalPlayingAreaDisplay || null,
        futsalPenaltyAreaDisplay: payload.futsalPenaltyAreaDisplay || null,
        netballPlayingAreaM: payload.netballPlayingAreaM || null,
        netballGoalPostM: payload.netballGoalPostM || null,
        netballPlayingAreaDisplay: payload.netballPlayingAreaDisplay || null,
        netballGoalPostDisplay: payload.netballGoalPostDisplay || null,
        goalPostRadiusM: payload.goalPostRadiusM ?? null,
        hoopModelPreset: payload.hoopModelPreset || null,
        hoopPresetGeometry: payload.hoopPresetGeometry || null,
        hoopsMode: payload.hoopsMode || null,
        hoopLineType: payload.hoopLineType || null,
        hoopSelection: payload.hoopSelection || null,
        borderSelection: payload.borderSelection || null,
        borderSizesM: payload.borderSizesM || null,
        view: payload.view || null,
        officialGeometry: payload.officialGeometry || null,
        basketballPaintGeometry: payload.basketballPaintGeometry || null,
        surfaceSettings: payload.surfaceSettings || null,
        config: payload.config || null,
        configRaw: payload.configRaw || null,
        logos: payload.logos || [],
        texts: payload.texts || [],
        logoFiles: fullBuilderPayload.logoFiles || [],
        logoUnit: payload.logoUnit || 'm',
        logoManifestUrl: payload.logoManifestUrl || null,
        uploadedLogoUrls,
        shareMedia: {
          exactPreviewUrl: submittedExactPreviewUrl || submittedShareUrl || null,
          shareHash: payload.shareHash || null,
          logoManifestUrl: payload.logoManifestUrl || null,
          errors: shareMediaInfo && Array.isArray(shareMediaInfo.errors) ? shareMediaInfo.errors : [],
          design2d: shareMediaInfo ? shareMediaInfo.design2d : null
        },
        preview: {
          width: previewInfo.width || null,
          height: previewInfo.height || null,
          type: previewInfo.type || null,
          bytes: previewInfo.bytes || null,
          uploadedUrl: submittedPreviewUrl || null
        },
        design2d: Object.assign({}, (shareMediaInfo && shareMediaInfo.design2d) || {}, {
          uploadedUrl: submittedDesign2dUrl || null
        }),
        attachments: logoAttachInfo
      };
      let detailsJson = '';
      try {
        detailsJson = JSON.stringify(details);
      } catch (_) {
        detailsJson = '';
      }
      if (getTextLength(detailsJson) > MAX_CONTACT_DETAILS_CHARS) {
        let detailsUploadUrl = '';
        if (uploadEndpoint) {
          try {
            setStatusMessage(form, 'Uploading full court settings JSON...', false);
            detailsUploadUrl = await uploadJsonFile(uploadEndpoint, detailsJson, 'swish-court-builder-settings.json');
          } catch (error) {
            detailsUploadUrl = '';
            appendSubmissionNote(
              submissionNotes,
              `The full Court Details JSON could not be uploaded separately: ${(error && error.message) || 'Upload failed.'}`
            );
          }
        }
        if (detailsUploadUrl) {
          details.fullSettingsJsonUrl = detailsUploadUrl;
          details.completeness.fullSettingsJsonUploaded = true;
          appendSubmissionNote(
            submissionNotes,
            `Full Court Details JSON was included in the form and also uploaded here: ${detailsUploadUrl}`
          );
          try { detailsJson = JSON.stringify(details); } catch (_) {}
        } else {
          appendSubmissionNote(
            submissionNotes,
            `Full Court Details JSON is included in the hidden form field even though it exceeds the legacy ${MAX_CONTACT_DETAILS_CHARS} character target.`
          );
        }
      }

      const summaryPayload = Object.assign({}, payload, {
        pageUrl: submittedPageUrl,
        shareUrl: submittedShareUrl
      });
      const summary = buildSummary(summaryPayload, previewInfo, logoAttachInfo, contactValues, root);
      const notesBlock = buildSubmissionNotesBlock(submissionNotes);
      const summaryWithNotes = notesBlock
        ? `${notesBlock.trim()}\n\n${summary}`
        : summary;
      const submittedBody = trimTextForField(summaryWithNotes, MAX_CONTACT_BODY_CHARS, 'Contact message');
      const submittedSummary = trimTextForField(summaryWithNotes, MAX_CONTACT_SUMMARY_CHARS, 'Court Summary');

      setFieldSubmissionValue(bodyField, submittedBody);
      setFieldSubmissionValue(summaryField, submittedSummary);
      setFieldSubmissionValue(detailsField, detailsJson);
      if (debugSession) {
        debugSession.mark('fields-populated', {
          bodyLength: bodyField.value ? bodyField.value.length : 0,
          summaryLength: summaryField.value ? summaryField.value.length : 0,
          detailsLength: detailsField.value ? detailsField.value.length : 0
        });
      }
      let intakeResult = null;
      try {
        intakeResult = await submitBuilderIntake(root, form, payload, {
          contactValues: contactValues,
          details: details,
          pageUrl: submittedPageUrl,
          previewUrl: submittedPreviewUrl,
          exactPreviewUrl: submittedExactPreviewUrl || submittedShareUrl,
          design2dUrl: submittedDesign2dUrl,
          shareMedia: {
            exactPreviewUrl: submittedExactPreviewUrl || submittedShareUrl || null,
            design2d: shareMediaInfo ? shareMediaInfo.design2d : null,
            errors: shareMediaInfo && Array.isArray(shareMediaInfo.errors) ? shareMediaInfo.errors : []
          },
          shareUrl: submittedShareUrl,
          summary: submittedSummary,
          logoUrls: uploadedLogoUrls,
          previewAttachment: previewAttachment
        });
        if (intakeResult && intakeResult.ok) {
          if (debugSession) debugSession.mark('swish-intake-posted');
        } else {
          const reason = intakeResult && (intakeResult.reason || intakeResult.error || (intakeResult.result && intakeResult.result.error));
          throw new Error(reason || 'The inquiry intake endpoint did not confirm delivery.');
        }
      } catch (error) {
        if (debugSession) {
          debugSession.mark('swish-intake-failed', {
            message: String((error && error.message) || error || 'Unknown intake error')
          });
        }
        try { console.warn('[Swish Court Builder] Intake post failed.', error); } catch (_) {}
        throw new Error('We could not send your message right now. Please try again in a moment.');
      }

      clearStatusMessage(form);
      setStatusMessage(form, 'Thanks. Your court inquiry has been sent.', false);
      setSubmittingState(form, false);

      if (debugSession) debugSession.mark('submit-complete-via-swish-intake');
      return {
        submitted: true,
        submitResult: {
          protected: false,
          method: 'swish-system-intake',
          nativeContact: false,
          intakePosted: !!(intakeResult && intakeResult.ok)
        }
      };
    } finally {
      form.dataset.swishcbContactSubmitting = '0';
    }
  }

  const boundContactForms = new WeakSet();

  function init() {
    const root = getRoot();
    const form = getContactForm(root);
    if (!form) return;
    if (boundContactForms.has(form)) return;
    boundContactForms.add(form);
    form.dataset.swishcbContactBound = '1';

    const primeFields = () => {
      prepareNativeContactPost(form);
      const pageUrlField = ensureField(form, '#swishcb-contact-page-url', 'input', {
        id: 'swishcb-contact-page-url',
        type: 'hidden',
        name: 'contact[Page URL]'
      });
      const shareUrlField = ensureField(form, '#swishcb-contact-share-url', 'input', {
        id: 'swishcb-contact-share-url',
        type: 'hidden',
        name: 'contact[Share URL]'
      });
      const exactPreviewUrlField = ensureField(form, '#swishcb-contact-exact-preview-url', 'input', {
        id: 'swishcb-contact-exact-preview-url',
        type: 'hidden',
        name: 'contact[Exact Preview URL]'
      });
      const design2dUrlField = ensureField(form, '#swishcb-contact-design-2d-url', 'input', {
        id: 'swishcb-contact-design-2d-url',
        type: 'hidden',
        name: 'contact[2D Design Image]'
      });
      const previewUrlField = form.querySelector('#swishcb-contact-preview');
      const bodyField = ensureHiddenTextarea(form, '#swishcb-contact-body', {
        id: 'swishcb-contact-body',
        name: 'contact[body]',
        hidden: ''
      });
      const payload = buildPrimePayload(form, root);
      const fallbackPageUrl = getCanonicalPageUrl(payload.pageUrl);
      const shareUrl = payload.shareUrl || payload.pageUrl || ((typeof window !== 'undefined' && window.location) ? window.location.href : fallbackPageUrl);
      ensureBuilderMetadataFields(
        root,
        form,
        fallbackPageUrl,
        (typeof window !== 'undefined' && window.location) ? window.location.origin : ''
      );
      setFieldSubmissionValue(pageUrlField, fallbackPageUrl);
      setFieldSubmissionValue(shareUrlField, shareUrl);
      setFieldSubmissionValue(exactPreviewUrlField, shareUrl);
      setFieldSubmissionValue(design2dUrlField, '');
      setFieldValue(previewUrlField, '');
      if (previewUrlField) previewUrlField.disabled = true;
      if (bodyField) {
        setFieldValue(bodyField, '');
        bodyField.disabled = false;
      }

      const previewFileInput = form.querySelector('#swishcb-contact-preview-file');
      const logoInput = form.querySelector('#swishcb-contact-logo-files');
      clearFileInput(previewFileInput);
      clearFileInput(logoInput);
    };
    let primeTimers = [];
    const clearPrimeTimers = () => {
      try {
        primeTimers.forEach((timer) => window.clearTimeout(timer));
      } catch (_) {}
      primeTimers = [];
    };
    const queuePrimeFields = (delay) => {
      const timer = window.setTimeout(() => {
        primeTimers = primeTimers.filter((value) => value !== timer);
        try { primeFields(); } catch (_) {}
      }, delay);
      primeTimers.push(timer);
    };
    const schedulePrimeFields = () => {
      clearPrimeTimers();
      queuePrimeFields(0);
      queuePrimeFields(80);
      queuePrimeFields(350);
      queuePrimeFields(1200);
      queuePrimeFields(2400);
    };

    const onSubmit = async (event) => {
      if (form.dataset.swishcbContactSubmitting === '1') return;
      event.preventDefault();
      clearStatusMessage(form);
      setSubmittingState(form, true);

      const debugSession = createDebugSession();
      debugSession.mark('submit-intercepted');

      let submitted = false;

      try {
        const api = await waitForApi(2000);
        debugSession.mark('api-ready', {
          available: !!api
        });
        const submission = await handleSubmit(form, api, root, debugSession);
        if (submission && submission.submitted) {
          submitted = true;
          publishDebugSession(debugSession, {
            status: 'submitted',
            submitResult: submission.submitResult || null
          });
        } else {
          if (submission && submission.reason === 'invalid') {
            setStatusMessage(form, 'Please complete the required fields and try again.', true);
          }
          publishDebugSession(debugSession, {
            status: 'skipped',
            reason: (submission && submission.reason) || 'unknown'
          });
        }
      } catch (error) {
        setStatusMessage(
          form,
          (error && error.message) || 'We could not send your message right now. Please try again.',
          true
        );
        publishDebugSession(debugSession, { status: 'failed' }, error);
      } finally {
        if (!submitted) {
          setSubmittingState(form, false);
        }
      }
    };

    if (isContactTestMode()) {
      window.__swishcbContactTest = {
        primeFields,
        buildPayload: () => buildPayload(getApi(), form, root),
        submitForTest: async (options) => {
          const opts = options && typeof options === 'object' ? options : {};
          const previousCaptcha = window.SwishShopifyCaptcha;
          const previousIntake = window.SwishSystemIntake;
          const previousPrepareShareAssets = window.SwishCourtBuilder && window.SwishCourtBuilder.prepareContactShareAssets;
          let capturedCaptcha = null;
          let capturedIntake = null;

          const makeFieldSnapshot = () => {
            const fields = {};
            try {
              Array.from(new FormData(form).entries()).forEach(([key, value]) => {
                fields[key] = typeof value === 'string' ? value : '[file]';
              });
            } catch (_) {}
            return fields;
          };

          if (opts.stubSubmit !== false) {
            window.SwishShopifyCaptcha = {
              shouldAllowNativeSubmit: () => false,
              submitForm: async (_form, submitOptions) => {
                capturedCaptcha = {
                  options: submitOptions ? { timeoutMs: submitOptions.timeoutMs || null } : null,
                  fields: makeFieldSnapshot()
                };
                return { protected: false, method: 'test-stub' };
              }
            };
          }

          if (opts.stubIntake !== false) {
            window.SwishSystemIntake = {
              ensureIntakeIdField: (_form) => {
                let field = _form.querySelector('input[name="contact[Intake ID]"]');
                if (!field) {
                  field = document.createElement('input');
                  field.type = 'hidden';
                  field.name = 'contact[Intake ID]';
                  _form.appendChild(field);
                }
                field.value = opts.intakeId || 'swishcb-contact-test';
                return field.value;
              },
              postThemePayload: async (_root, payload) => {
                capturedIntake = payload;
                return { ok: true, stubbed: true };
              }
            };
          }

          if (opts.stubShareMedia !== false && window.SwishCourtBuilder) {
            window.SwishCourtBuilder.prepareContactShareAssets = async () => ({
              ok: true,
              shareUrl: opts.exactPreviewUrl || 'https://swishcourt.com/pages/fiba-basketball-court-flooring#swishcb=v=4&ct=fiba&u=m&l=32&w=19&view=3d',
              shareHash: '#swishcb=v=4&ct=fiba&u=m&l=32&w=19&view=3d',
              shareData: { v: '4', ct: 'fiba', u: 'm', l: 32, w: 19, view: '3d' },
              logoManifestUrl: opts.logoManifestUrl || '',
              design2d: {
                mode: '2d',
                kind: 'image',
                fileName: 'swish-court-2d-design.png',
                mimeType: 'image/png',
                width: 1600,
                height: 900,
                publicUrl: opts.design2dUrl || 'https://cdn.shopify.com/s/files/test/swish-court-2d-design.png'
              },
              errors: []
            });
          }

          const debugSession = createDebugSession();
          debugSession.mark('test-submit-start');

          try {
            const api = await waitForApi(Number(opts.timeoutMs) || 2000);
            debugSession.mark('api-ready', { available: !!api });
            const submission = await handleSubmit(form, api, root, debugSession);
            publishDebugSession(debugSession, {
              status: submission && submission.submitted ? 'submitted' : 'skipped',
              reason: submission && submission.reason ? submission.reason : null,
              submitResult: submission && submission.submitResult ? submission.submitResult : null
            });

            const detailsField = form.querySelector('#swishcb-contact-details');
            const summaryField = form.querySelector('#swishcb-contact-summary');
            const bodyField = form.querySelector('#swishcb-contact-body');
            const detailsJson = detailsField ? String(detailsField.value || '') : '';
            let details = null;
            try { details = detailsJson ? JSON.parse(detailsJson) : null; } catch (_) { details = null; }

            return {
              submission,
              debug: window.__swishcbContactLastSubmission || null,
              details,
              detailsJson,
              detailsLength: detailsJson.length,
              summary: summaryField ? String(summaryField.value || '') : '',
              body: bodyField ? String(bodyField.value || '') : '',
              capturedCaptcha,
              capturedIntake
            };
          } finally {
            if (opts.restoreGlobals !== false) {
              window.SwishShopifyCaptcha = previousCaptcha;
              window.SwishSystemIntake = previousIntake;
              if (window.SwishCourtBuilder) {
                if (previousPrepareShareAssets) {
                  window.SwishCourtBuilder.prepareContactShareAssets = previousPrepareShareAssets;
                } else {
                  try { delete window.SwishCourtBuilder.prepareContactShareAssets; } catch (_) {
                    window.SwishCourtBuilder.prepareContactShareAssets = undefined;
                  }
                }
              }
            }
          }
        }
      };
    }

    primeFields();
    window.setTimeout(() => { try { primeFields(); } catch (_) {} }, 250);
    window.setTimeout(() => { try { primeFields(); } catch (_) {} }, 1000);
    clearStatusMessage(form);
    root.addEventListener('input', schedulePrimeFields, true);
    root.addEventListener('change', schedulePrimeFields, true);
    window.addEventListener('hashchange', schedulePrimeFields);
    window.addEventListener('swish:ruleset-changed', schedulePrimeFields);
    window.addEventListener('swish:dimensions-changed', schedulePrimeFields);
    window.addEventListener('swish:units-changed', schedulePrimeFields);
    window.addEventListener('swish:dimension-display-changed', schedulePrimeFields);
    window.addEventListener('swish:builder-state-changed', schedulePrimeFields);
    form.addEventListener('submit', onSubmit, true);
    form.addEventListener('submit', onSubmit);

    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitButton) {
      submitButton.addEventListener('click', onSubmit, true);
    }
  }

  if (!HAS_DOM) {
    if (typeof module !== 'undefined' && module.exports) {
      module.exports = { shouldGeneratePreviewData };
    }
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  if (typeof MutationObserver !== 'undefined') {
    let initTimer = null;
    const observer = new MutationObserver(() => {
      if (initTimer !== null) return;
      initTimer = window.setTimeout(() => {
        initTimer = null;
        init();
      }, 0);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
